import React, { useEffect, useState, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { get } from '../../utils/api'
import ReportTable from './ReportTable'
import styles from '../../styles/gri/report.module.css'
import { truncateNumber } from '../../utils/common'

const GRI300 = () => {
  const { id } = useParams()
  const [loading, setLoading] = useState(true)
  
  // GRI 301 - Materials
  const [materialUsedData, setMaterialUsedData] = useState(null)
  const [recycledInputData, setRecycledInputData] = useState(null)
  const [reclaimedProductsData, setReclaimedProductsData] = useState(null)
  const [dataDisclosureData, setDataDisclosureData] = useState(null)
  
  // GRI 302 - Energy
  const [energyConsumptionData, setEnergyConsumptionData] = useState(null)
  const [energyConsumptionOutsideData, setEnergyConsumptionOutsideData] = useState(null)
  const [energyIntensityData, setEnergyIntensityData] = useState(null)
  const [energyReductionData, setEnergyReductionData] = useState(null)
  const [energyRequirementsReductionData, setEnergyRequirementsReductionData] = useState(null)
  
  // GRI 303 - Water
  const [sharedResourceData, setSharedResourceData] = useState(null)
  const [waterDischargeData, setWaterDischargeData] = useState(null)
  const [waterConsumptionData, setWaterConsumptionData] = useState(null)
  const [waterWithdrawalData, setWaterWithdrawalData] = useState(null)
  const [waterManagementData, setWaterManagementData] = useState(null)
  
  // GRI 304 - Biodiversity
  const [operationalSitesBiodiversityData, setOperationalSitesBiodiversityData] = useState(null)
  const [significantImpactsData, setSignificantImpactsData] = useState(null)
  const [habitatsProtectedData, setHabitatsProtectedData] = useState(null)
  const [iucnRedListConservationSpeciesData, setIucnRedListConservationSpeciesData] = useState(null)
  
  // GRI 305 - Emissions
  const [scope1EmissionsData, setScope1EmissionsData] = useState(null)
  const [scope2EmissionsData, setScope2EmissionsData] = useState(null)
  const [scope3EmissionsData, setScope3EmissionsData] = useState(null)
  const [emissionsIntensityData, setEmissionsIntensityData] = useState(null)
  const [emissionsReductionData, setEmissionsReductionData] = useState(null)
  const [ozoneDepletingData, setOzoneDepletingData] = useState(null)
  const [airEmissionsNOxSOxData, setAirEmissionsNOxSOxData] = useState(null)
  
  // GRI 306 - Waste
  const [wasteRelatedImpactData, setWasteRelatedImpactData] = useState(null)
  const [wasteImpactManagementData, setWasteImpactManagementData] = useState(null)
  const [wasteGeneratedData, setWasteGeneratedData] = useState(null)
  const [wasteDivertedData, setWasteDivertedData] = useState(null)
  const [wasteToDisposalData, setWasteToDisposalData] = useState(null)
  
  // GRI 308 - Supplier Environmental Assessment
  const [supplierData, setSupplierData] = useState(null)
  const [supplyChainImpactsActionsData, setSupplyChainImpactsActionsData] = useState(null)

  useEffect(() => {
    fetchData()
  }, [id])

  const fetchData = async () => {
    try {
      setLoading(true)
      const res = await get(`/gri/get?Id=${id}&type=GRI300`)
      const gri300Data = res?.data?.data?.GRI300 || {}
      
      // GRI 301 - Materials
      setMaterialUsedData(gri300Data?.materialUsedWeightOrVolumn || null)
      setRecycledInputData(gri300Data?.recycledInput || null)
      setReclaimedProductsData(gri300Data?.percentageOfReclaimed || null)
      setDataDisclosureData(gri300Data?.dataDisclosure || null)
      
      // GRI 302 - Energy
      setEnergyConsumptionData(gri300Data?.energyConsumption || null)
      setEnergyConsumptionOutsideData(gri300Data?.energyConsumptionOutside || null)
      setEnergyIntensityData(gri300Data?.energyIntensity || null)
      setEnergyReductionData(gri300Data?.reductionofEnergy || null)
      setEnergyRequirementsReductionData(gri300Data?.reductionEnergyRequirement || null)
      
      // GRI 303 - Water
      setSharedResourceData(gri300Data?.sharedResource || null)
      setWaterDischargeData(gri300Data?.waterDischarge || null)
      setWaterConsumptionData(gri300Data?.waterConsumption || null)
      setWaterWithdrawalData(gri300Data?.waterWithdrawal || null)
      setWaterManagementData(gri300Data?.waterManagement || null)
      
      // GRI 304 - Biodiversity
      setOperationalSitesBiodiversityData(gri300Data?.operationalSitesBiodiversity || null)
      setSignificantImpactsData(gri300Data?.significantImpact || null)
      setHabitatsProtectedData(gri300Data?.habitatsProtected || null)
      setIucnRedListConservationSpeciesData(gri300Data?.iucnRedListConservationSpecies || null)
      
      // GRI 305 - Emissions
      setScope1EmissionsData(gri300Data?.scope1Emissions || null)
      setScope2EmissionsData(gri300Data?.scope2Emissions || null)
      setScope3EmissionsData(gri300Data?.scope3Emissions || null)
      setEmissionsIntensityData(gri300Data?.intensity || null)
      setEmissionsReductionData(gri300Data?.reduction || null)
      setOzoneDepletingData(gri300Data?.ozoneDepleting || null)
      setAirEmissionsNOxSOxData(gri300Data?.airEmissionsNOxSOx || null)
      
      // GRI 306 - Waste
      setWasteRelatedImpactData(gri300Data?.wasteRelatedImpact || null)
      setWasteImpactManagementData(gri300Data?.wasteImpactManagement || null)
      setWasteGeneratedData(gri300Data?.wasteGenerated || null)
      setWasteDivertedData(gri300Data?.disposal || null)
      setWasteToDisposalData(gri300Data?.wasteToDisposal || null)
      
      // GRI 308 - Supplier Environmental Assessment
      setSupplierData(gri300Data?.supplier || null)
      setSupplyChainImpactsActionsData(gri300Data?.supplyChainImpactsActions || null)
    } catch (err) {
      console.log('Error fetching GRI 300 data:', err)
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
  return (
      <div className={styles.loadingContainer}>
        <p>Loading...</p>
      </div>
    )
  }

  return (
    <>
      {/* GRI 301 - Materials Used */}
      <div className={styles.container}>
        <p className={styles.sectionHeading}>
          301: MATERIAL USED
        </p>
        <h1 className={styles.mainHeading}>
          301-1 : MATERIALS USED BY WEIGHT OR VOLUME
        </h1>
        
        {/* 301-1: Materials used by weight or volume */}
        {materialUsedData && Array.isArray(materialUsedData) && materialUsedData.length > 0 ? (
          <div className={styles.consolidatingSection}>
            <p className={`${styles.consolidatingTitle} common_text_style`}>
              a. Total weight or volume of materials that are used to produce and package the organization's primary products and services during the reporting period, by:
            </p>
            
            {materialUsedData.map((product, productIndex) => {
              const measurementUnit = product?.measurementUnit
              const unitType = measurementUnit?.mass?.active ? 'Mass' : 'Volume'
              const unitValue = measurementUnit?.mass?.active 
                ? measurementUnit?.mass?.remark 
                : measurementUnit?.volume?.remark
              
              // Prepare table data
              const materialColumns = [
                { field: 'materialUsed', label: 'Material Used', width: '25%' },
                { field: 'rawMaterials', label: 'Raw Materials Used', width: '15%' },
                { field: 'processMaterials', label: 'Process Materials', width: '15%' },
                { field: 'semiManufactured', label: 'Semi Manufactured', width: '15%' },
                { field: 'packagingMaterials', label: 'Packaging Materials', width: '15%' }
              ]
              
              const materialRows = [
                {
                  materialUsed: 'NonRenewable Materials Used',
                  rawMaterials: product?.nonrenewable?.rawMaterial || '-',
                  processMaterials: product?.nonrenewable?.processMaterials || '-',
                  semiManufactured: product?.nonrenewable?.semiManufactured || '-',
                  packagingMaterials: product?.nonrenewable?.packagingMaterials || '-'
                },
                {
                  materialUsed: 'Renewable Materials Used',
                  rawMaterials: product?.renewable?.rawMaterial || '-',
                  processMaterials: product?.renewable?.processMaterials || '-',
                  semiManufactured: product?.renewable?.semiManufactured || '-',
                  packagingMaterials: product?.renewable?.packagingMaterials || '-'
                }
              ]
              
              return (
                <div key={productIndex} className={styles.questionBox}>
                  {product?.productName && (
                    <p className={styles.productName}>
                      Product Name: {product.productName}
                    </p>
                  )}
                  {unitValue && (
                    <p className={styles.productInfo}>
                      Measurement unit: {unitType} ({unitValue})
                    </p>
                  )}
                  
                  <ReportTable
                    columns={materialColumns}
                    rows={materialRows}
                    showSerialNumber={true}
                  />
                </div>
              )
            })}
          </div>
        ) : (
          <div className={styles.consolidatingSection}>
            <p className={`${styles.consolidatingTitle} common_text_style`}>
              a. Total weight or volume of materials that are used to produce and package the organization's primary products and services during the reporting period, by:
            </p>
            <div className={styles.questionsContainer}>
              <div className={styles.questionBox}>
                <p className={styles.questionAnswer}>
                  -
                </p>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* GRI 301-2 - Recycled Input Materials Used */}
      <div className={styles.container}>
     
        <h1 className={styles.mainHeading}>
          301-2 : RECYCLED INPUT MATERIALS USED
        </h1>
        
        {recycledInputData && Array.isArray(recycledInputData) && recycledInputData.length > 0 ? (
          <div className={styles.consolidatingSection}>
            <p className={`${styles.consolidatingTitle} common_text_style`}>
              a. Percentage of recycled input materials used to manufacture the organization's primary products and services.
            </p>
            
            {(() => {
              // Calculate totals across all products
              let totalInputMaterial = 0
              let totalInputRecycled = 0
              
              recycledInputData.forEach((product) => {
                if (product?.renewable) {
                  totalInputMaterial += Number(product.renewable.totaInputMaterials) || 0
                  totalInputRecycled += Number(product.renewable.totalRecycled) || 0
                }
                if (product?.nonrenewable) {
                  totalInputMaterial += Number(product.nonrenewable.totaInputMaterials) || 0
                  totalInputRecycled += Number(product.nonrenewable.totalRecycled) || 0
                }
              })
              
              const percentageOfRecycled = totalInputMaterial > 0
                ? (totalInputRecycled / totalInputMaterial) * 100
                : 0
              
              // Get unit from first product
              const firstProduct = recycledInputData[0]
              const measurementUnit = firstProduct?.measurementUnit
              const unitValue = measurementUnit?.mass?.active 
                ? measurementUnit?.mass?.remark 
                : measurementUnit?.volume?.remark || 'Kg'
              
              return (
                <>
                  {recycledInputData.map((product, productIndex) => {
                    const productMeasurementUnit = product?.measurementUnit
                    const unitType = productMeasurementUnit?.mass?.active ? 'Mass' : 'Volume'
                    const productUnitValue = productMeasurementUnit?.mass?.active 
                      ? productMeasurementUnit?.mass?.remark 
                      : productMeasurementUnit?.volume?.remark || 'Kg'
                    
                    // Prepare table data
                    const recycledColumns = [
                      { field: 'materialUsed', label: 'Material Used', width: '30%' },
                      { field: 'totalInputMaterials', label: 'Total Input Materials Used', width: '20%' },
                      { field: 'totalRecycled', label: 'Total Recycled Input Materials Used', width: '25%' },
                      { field: 'percentage', label: 'Percentage of Recycled Input Materials Used', width: '25%' }
                    ]
                    
                    const recycledRows = [
                      {
                        materialUsed: 'Non-Renewable Materials Used',
                        totalInputMaterials: product?.nonrenewable?.totaInputMaterials || '-',
                        totalRecycled: product?.nonrenewable?.totalRecycled || '-',
                        percentage: product?.nonrenewable?.percentage ? `${product.nonrenewable.percentage}%` : '-'
                      },
                      {
                        materialUsed: 'Renewable Materials Used',
                        totalInputMaterials: product?.renewable?.totaInputMaterials || '-',
                        totalRecycled: product?.renewable?.totalRecycled || '-',
                        percentage: product?.renewable?.percentage ? `${product.renewable.percentage}%` : '-'
                      }
                    ]
                    
                    return (
                      <div key={productIndex} className={styles.questionBox}>
                        {product?.productName && (
                          <p className={styles.productName}>
                            Product Name: {product.productName}
                          </p>
                        )}
                        {productUnitValue && (
                          <p className={styles.productInfo}>
                            Measurement unit: {unitType} ({productUnitValue})
                          </p>
                        )}
                        
                        <ReportTable
                          columns={recycledColumns}
                          rows={recycledRows}
                          showSerialNumber={true}
                        />
                      </div>
                    )
                  })}
                  
                  {/* Grand Totals Section */}
                  <div className={styles.totalsContainer}>
                    <div>
                      <p className={styles.totalLabel}>
                        Total Input Material Used in {unitValue}
                      </p>
                      <p className={styles.totalValue}>
                        {truncateNumber(totalInputMaterial)}
                      </p>
                      <p className={styles.totalLabel}>
                        Percentage of recycled input materials used
                      </p>
                      <p>{truncateNumber(percentageOfRecycled)}%</p>
                    </div>
                    <div>
                      <p className={styles.totalLabel}>
                        Total Input Recycled Material Used in {unitValue}
                      </p>
                      <p>{truncateNumber(totalInputRecycled)}</p>
                    </div>
                  </div>
                </>
              )
            })()}
          </div>
        ) : (
          <div className={styles.consolidatingSection}>
            <p className={`${styles.consolidatingTitle} common_text_style`}>
              a. Percentage of recycled input materials used to manufacture the organization's primary products and services.
            </p>
            <div className={styles.questionsContainer}>
              <div className={styles.questionBox}>
                <p className={styles.questionAnswer}>
                  -
                </p>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* GRI 301-3 - Reclaimed Products and Their Packaging Materials */}
      <div className={styles.container}>
     
        <h1 className={styles.mainHeading}>
          301-3 : RECLAIMED PRODUCTS AND THEIR PACKAGING MATERIALS
        </h1>
        
        {/* 301-3: Reclaimed products and their packaging materials */}
        {reclaimedProductsData && Array.isArray(reclaimedProductsData) && reclaimedProductsData.length > 0 ? (
          <div className={styles.consolidatingSection}>
            <p className={`${styles.consolidatingTitle} common_text_style`}>
              a. Percentage of reclaimed products and their packaging materials for each product category.
            </p>
            
            {(() => {
              // Prepare table data
              const reclaimedColumns = [
                { field: 'productName', label: 'Product Name', width: '20%' },
                { field: 'productPackaging', label: 'Products and their packaging materials reclaimed within the reporting period', width: '30%' },
                { field: 'productSold', label: 'Products sold within the reporting period', width: '25%' },
                { field: 'percentage', label: 'Percentage of reclaimed products and their packaging materials', width: '25%' }
              ]
              
              const reclaimedRows = reclaimedProductsData.map((item) => ({
                productName: item?.productName || '-',
                productPackaging: item?.productPackaging || '-',
                productSold: item?.productSold || '-',
                percentage: item?.percentage ? `${item.percentage}%` : '-'
              }))
              
              return (
                <>
                  <ReportTable
                    columns={reclaimedColumns}
                    rows={reclaimedRows}
                    showSerialNumber={true}
                  />
                  
                  {/* Section b: How the data for this disclosure have been collected */}
                  {dataDisclosureData && (
                    <div className={`${styles.consolidatingSection} ${styles.subSectionMargin}`}>
                      <p className={`${styles.consolidatingTitle} common_text_style`}>
                        b. How the data for this disclosure have been collected.
                      </p>
                      <div className={styles.questionsContainer}>
                        <div className={styles.questionBox}>
                          <p className={styles.questionAnswer}>
                            {dataDisclosureData || '-'}
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )
            })()}
          </div>
        ) : (
          <div className={styles.consolidatingSection}>
            <p className={`${styles.consolidatingTitle} common_text_style`}>
              a. Percentage of reclaimed products and their packaging materials for each product category.
            </p>
            <div className={styles.questionsContainer}>
              <div className={styles.questionBox}>
                <p className={styles.questionAnswer}>
                  -
                </p>
              </div>
            </div>
            
            {/* Section b: How the data for this disclosure have been collected */}
            {dataDisclosureData && (
              <div className={`${styles.consolidatingSection} ${styles.subSectionMargin}`}>
                <p className={`${styles.consolidatingTitle} common_text_style`}>
                  b. How the data for this disclosure have been collected.
                </p>
                <div className={styles.questionsContainer}>
                  <div className={styles.questionBox}>
                    <p className={styles.questionAnswer}>
                      {dataDisclosureData || '-'}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* GRI 302-1 - Energy Consumption Within the Organization */}
      <div className={styles.container}>
        <p className={styles.sectionHeading}>
          302: ENERGY
        </p>
        <h1 className={styles.mainHeading}>
          302-1 : ENERGY CONSUMPTION WITHIN THE ORGANIZATION
        </h1>
        
        {energyConsumptionData ? (
          <div className={styles.consolidatingSection}>
            {/* Sub-section a: Total fuel consumption from non-renewable sources */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. Total fuel consumption within the organization from non-renewable sources.
              </p>
              <div className={styles.questionRow}>
                <span className={styles.questionLabel}>Amount:</span>
                <span className={styles.questionValue}>
                  {energyConsumptionData?.totalFuelConsumptionNonRenewable?.amount || '-'}
                </span>
              </div>
              <div className={styles.questionRow}>
                <span className={styles.questionLabel}>Unit:</span>
                <span className={styles.questionValue}>
                  {energyConsumptionData?.totalFuelConsumptionNonRenewable?.unit || '-'}
                </span>
              </div>
            </div>

            {/* Sub-section b: Total fuel consumption from renewable sources */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                b. Total fuel consumption within the organization from renewable sources.
              </p>
              <div className={styles.questionRow}>
                <span className={styles.questionLabel}>Amount:</span>
                <span className={styles.questionValue}>
                  {energyConsumptionData?.totalRenewableFuelConsumption?.amount || '-'}
                </span>
              </div>
              <div className={styles.questionRow}>
                <span className={styles.questionLabel}>Unit:</span>
                <span className={styles.questionValue}>
                  {energyConsumptionData?.totalRenewableFuelConsumption?.unit || '-'}
                </span>
              </div>
            </div>

            {/* Sub-section c: Breakdown of energy consumed */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                c. Provide breakdown of energy consumed.
              </p>
              {(() => {
                const energyConsumptionColumns = [
                  { field: 'equipmentName', label: 'Equipment Name', width: '40%' },
                  { field: 'amount', label: 'Amount', width: '30%' },
                  { field: 'unit', label: 'Unit', width: '30%' }
                ]
                
                const energyConsumptionRows = energyConsumptionData?.energyConsumption ? [
                  {
                    equipmentName: 'Total electricity consumption within the organization',
                    amount: energyConsumptionData?.energyConsumption?.electricity?.amount || '-',
                    unit: energyConsumptionData?.energyConsumption?.electricity?.unit || '-'
                  },
                  {
                    equipmentName: 'Total heating consumption within the organization',
                    amount: energyConsumptionData?.energyConsumption?.heat?.amount || '-',
                    unit: energyConsumptionData?.energyConsumption?.heat?.unit || '-'
                  },
                  {
                    equipmentName: 'Total cooling consumption within the organization',
                    amount: energyConsumptionData?.energyConsumption?.cooling?.amount || '-',
                    unit: energyConsumptionData?.energyConsumption?.cooling?.unit || '-'
                  },
                  {
                    equipmentName: 'Total steam consumption within the organization',
                    amount: energyConsumptionData?.energyConsumption?.steam?.amount || '-',
                    unit: energyConsumptionData?.energyConsumption?.steam?.unit || '-'
                  }
                ].filter(row => row.amount !== '-' || row.unit !== '-') : []
                
                return (
                  <ReportTable
                    columns={energyConsumptionColumns}
                    rows={energyConsumptionRows}
                    showSerialNumber={true}
                  />
                )
              })()}
            </div>

            {/* Sub-section d: Breakdown of energy sold */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                d. Provide breakdown of energy sold.
              </p>
              {(() => {
                const energySoldColumns = [
                  { field: 'equipmentName', label: 'Equipment Name', width: '40%' },
                  { field: 'amount', label: 'Amount', width: '30%' },
                  { field: 'unit', label: 'Unit', width: '30%' }
                ]
                
                const energySoldRows = energyConsumptionData?.energySold ? [
                  {
                    equipmentName: 'Total electricity sold',
                    amount: energyConsumptionData?.energySold?.electricity?.amount || '-',
                    unit: energyConsumptionData?.energySold?.electricity?.unit || '-'
                  },
                  {
                    equipmentName: 'Total heating sold',
                    amount: energyConsumptionData?.energySold?.heat?.amount || '-',
                    unit: energyConsumptionData?.energySold?.heat?.unit || '-'
                  },
                  {
                    equipmentName: 'Total cooling sold',
                    amount: energyConsumptionData?.energySold?.cooling?.amount || '-',
                    unit: energyConsumptionData?.energySold?.cooling?.unit || '-'
                  },
                  {
                    equipmentName: 'Total steam sold',
                    amount: energyConsumptionData?.energySold?.steam?.amount || '-',
                    unit: energyConsumptionData?.energySold?.steam?.unit || '-'
                  }
                ].filter(row => row.amount !== '-' || row.unit !== '-') : []
                
                return (
                  <ReportTable
                    columns={energySoldColumns}
                    rows={energySoldRows}
                    showSerialNumber={true}
                  />
                )
              })()}
            </div>

            {/* Sub-section e: Total energy consumption */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                e. Total energy consumption within the organization.
              </p>
              <div className={styles.questionRow}>
                <span className={styles.questionLabel}>Amount:</span>
                <span className={styles.questionValue}>
                  {energyConsumptionData?.totalEnergyConsumption?.amount || '-'}
                </span>
              </div>
              <div className={styles.questionRow}>
                <span className={styles.questionLabel}>Unit:</span>
                <span className={styles.questionValue}>
                  {energyConsumptionData?.totalEnergyConsumption?.unit || '-'}
                </span>
              </div>
            </div>

            {/* Sub-section f: Standards and methodologies */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                f. Describe the standard, methodologies, assumptions, and/or calculation tools used.
              </p>
              <p className={styles.questionAnswer}>
                {energyConsumptionData?.standardsMethodologies || '-'}
              </p>
            </div>

            {/* Sub-section g: Conversion factors */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                g. Provide the source of the conversion factors used.
              </p>
              <p className={styles.questionAnswer}>
                {energyConsumptionData?.conversionFactors || '-'}
              </p>
            </div>
          </div>
        ) : (
          <div className={styles.consolidatingSection}>
            {/* Sub-section a: Total fuel consumption from non-renewable sources */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. Total fuel consumption within the organization from non-renewable sources.
              </p>
              <div className={styles.questionRow}>
                <span className={styles.questionLabel}>Amount:</span>
                <span className={styles.questionValue}>-</span>
              </div>
              <div className={styles.questionRow}>
                <span className={styles.questionLabel}>Unit:</span>
                <span className={styles.questionValue}>-</span>
              </div>
            </div>

            {/* Sub-section b: Total fuel consumption from renewable sources */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                b. Total fuel consumption within the organization from renewable sources.
              </p>
              <div className={styles.questionRow}>
                <span className={styles.questionLabel}>Amount:</span>
                <span className={styles.questionValue}>-</span>
              </div>
              <div className={styles.questionRow}>
                <span className={styles.questionLabel}>Unit:</span>
                <span className={styles.questionValue}>-</span>
              </div>
            </div>

            {/* Sub-section c: Breakdown of energy consumed */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                c. Provide breakdown of energy consumed.
              </p>
              <ReportTable
                columns={[
                  { field: 'equipmentName', label: 'Equipment Name', width: '40%' },
                  { field: 'amount', label: 'Amount', width: '30%' },
                  { field: 'unit', label: 'Unit', width: '30%' }
                ]}
                rows={[]}
                showSerialNumber={true}
              />
            </div>

            {/* Sub-section d: Breakdown of energy sold */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                d. Provide breakdown of energy sold.
              </p>
              <ReportTable
                columns={[
                  { field: 'equipmentName', label: 'Equipment Name', width: '40%' },
                  { field: 'amount', label: 'Amount', width: '30%' },
                  { field: 'unit', label: 'Unit', width: '30%' }
                ]}
                rows={[]}
                showSerialNumber={true}
              />
            </div>
          </div>
        )}
      </div>

      {/* GRI 302-2 - Energy Consumption Outside of the Organization */}
      <div className={styles.container}>
     
        <h1 className={styles.mainHeading}>
          302-2 : ENERGY CONSUMPTION OUTSIDE OF THE ORGANIZATION
        </h1>
        
        {energyConsumptionOutsideData ? (
          <div className={styles.consolidatingSection}>
            {/* Sub-section a: Energy consumption outside of the organization */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. Energy consumption outside of the organization
              </p>
              {(() => {
                const outsideColumns = [
                  { field: 'category', label: 'Categories', width: '15%' },
                  { field: 'outsideBoundry', label: 'Activity outside organizational boundary', width: '25%' },
                  { field: 'consumption', label: 'Consumption', width: '15%' },
                  { field: 'unit', label: 'Unit', width: '15%' },
                  { field: 'remark', label: 'Remark', width: '30%' }
                ]
                
                const outsideRows = energyConsumptionOutsideData?.outsideOrganization && Array.isArray(energyConsumptionOutsideData.outsideOrganization) && energyConsumptionOutsideData.outsideOrganization.length > 0
                  ? energyConsumptionOutsideData.outsideOrganization.map((item) => ({
                      category: item?.category || '-',
                      outsideBoundry: item?.outsideBoundry || '-',
                      consumption: item?.consumption || '-',
                      unit: item?.unit || '-',
                      remark: item?.remark || '-'
                    }))
                  : []
                
                return (
                  <ReportTable
                    columns={outsideColumns}
                    rows={outsideRows}
                    showSerialNumber={true}
                  />
                )
              })()}
            </div>

            {/* Sub-section b: Standards and methodologies */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                b. Describe the standard, methodologies, assumptions, and/or calculation tools used.
              </p>
              <p className={styles.questionAnswer}>
                {energyConsumptionOutsideData?.standardsMethodologies || '-'}
              </p>
            </div>

            {/* Sub-section c: Conversion factors */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                c. Provide the source of the conversion factors used.
              </p>
              <p className={styles.questionAnswer}>
                {energyConsumptionOutsideData?.conversionFactors || '-'}
              </p>
            </div>
          </div>
        ) : (
          <div className={styles.consolidatingSection}>
            {/* Sub-section a: Energy consumption outside of the organization */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. Energy consumption outside of the organization
              </p>
              <ReportTable
                columns={[
                  { field: 'category', label: 'Categories', width: '15%' },
                  { field: 'outsideBoundry', label: 'Activity outside organizational boundary', width: '25%' },
                  { field: 'consumption', label: 'Consumption', width: '15%' },
                  { field: 'unit', label: 'Unit', width: '15%' },
                  { field: 'remark', label: 'Remark', width: '30%' }
                ]}
                rows={[]}
                showSerialNumber={true}
              />
            </div>
          </div>
        )}
      </div>

      {/* GRI 302-3 - Energy Intensity */}
      <div className={styles.container}>
   
        <h1 className={styles.mainHeading}>
          302-3 : ENERGY INTENSITY
        </h1>
        
        {energyIntensityData ? (
          <div className={styles.consolidatingSection}>
            {/* Sub-section a: Energy intensity ratio */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. Energy intensity ratio for the organization.
              </p>
              {(() => {
                const intensityColumns = [
                  { field: 'metric', label: 'Energy consumed per metrics', width: '50%' },
                  { field: 'value', label: 'Value', width: '50%' }
                ]
                
                const intensityRows = [
                  {
                    metric: 'Product',
                    value: energyIntensityData?.product || '-'
                  },
                  {
                    metric: 'Services',
                    value: energyIntensityData?.service || '-'
                  },
                  {
                    metric: 'Sales',
                    value: energyIntensityData?.sales || '-'
                  }
                ]
                
                return (
                  <ReportTable
                    columns={intensityColumns}
                    rows={intensityRows}
                    showSerialNumber={true}
                  />
                )
              })()}
            </div>

            {/* Sub-section b: Organization-specific metrics */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                b. Organization-specific metrics (denominators)
              </p>
              <p className={styles.questionAnswer}>
                {energyIntensityData?.organizationspecificmetrics || '-'}
              </p>
            </div>

            {/* Sub-section c: Types of energy included */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                c. Types of energy included in the intensity ratio
              </p>
              <p className={styles.subQuestionTitle}>
                (i) Which types of energy are included in the intensity ratio? (e.g., fuel, electricity, heating, cooling, steam, or all)
              </p>
              <p className={styles.questionAnswer}>
                {energyIntensityData?.engeryInclude && energyIntensityData.engeryInclude.length > 0 ? energyIntensityData.engeryInclude.join(', ') : '-'}
              </p>
            </div>

            {/* Sub-section d: Energy consumption scope */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                d. Whether the ratio uses energy consumption within the organization, outside of it, or both:
              </p>
              <p className={styles.subQuestionTitle}>
                (i) Does the ratio use energy consumption within the organization, outside of it, or both?
              </p>
              <p className={styles.questionAnswer}>
                {energyIntensityData?.energyConsumptionWithinOrg || '-'}
              </p>
            </div>
          </div>
        ) : (
          <div className={styles.consolidatingSection}>
            {/* Sub-section a: Energy intensity ratio */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. Energy intensity ratio for the organization.
              </p>
              <ReportTable
                columns={[
                  { field: 'metric', label: 'Energy consumed per metrics', width: '50%' },
                  { field: 'value', label: 'Value', width: '50%' }
                ]}
                rows={[
                  { metric: 'Product', value: '-' },
                  { metric: 'Services', value: '-' },
                  { metric: 'Sales', value: '-' }
                ]}
                showSerialNumber={true}
              />
            </div>
          </div>
        )}
      </div>

      {/* GRI 302-4 - Reduction of Energy Consumption */}
      <div className={styles.container}>
    
        <h1 className={styles.mainHeading}>
          302-4 : REDUCTION OF ENERGY CONSUMPTION
        </h1>

        
        {energyReductionData ? (
          <div className={styles.consolidatingSection}>
            {/* Sub-section a: Amount of reductions */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. Amount of reductions in energy consumption achieved as a direct result of conservation and efficiency initiatives
              </p>
              <div className={styles.questionRow}>
                <span className={styles.questionLabel}>Total reduction in energy consumption:</span>
                <span className={styles.questionValue}>
                  {energyReductionData?.energyConsumption || '-'}
                </span>
              </div>
            </div>

            {/* Breakdown of reduction initiatives */}
            <div className={styles.questionBox}>
              {(() => {
                const reductionColumns = [
                  { field: 'initiative', label: 'Reduction initiatives', width: '30%' },
                  { field: 'value', label: 'Value', width: '20%' },
                  { field: 'unit', label: 'Unit', width: '20%' },
                  { field: 'remark', label: 'Remark', width: '30%' }
                ]
                
                const reductionRows = energyReductionData?.reductionEnergy === 'Yes' && energyReductionData?.consumption ? [
                  {
                    initiative: 'Process Redesign',
                    value: energyReductionData?.consumption?.process?.value || '-',
                    unit: energyReductionData?.consumption?.process?.unit || '-',
                    remark: energyReductionData?.consumption?.process?.remark || '-'
                  },
                  {
                    initiative: 'Conversion and Retrofitting of Equipment',
                    value: energyReductionData?.consumption?.conversion?.value || '-',
                    unit: energyReductionData?.consumption?.conversion?.unit || '-',
                    remark: energyReductionData?.consumption?.conversion?.remark || '-'
                  },
                  {
                    initiative: 'Changes in Behavior',
                    value: energyReductionData?.consumption?.change?.value || '-',
                    unit: energyReductionData?.consumption?.change?.unit || '-',
                    remark: energyReductionData?.consumption?.change?.remark || '-'
                  },
                  {
                    initiative: 'Operational Changes',
                    value: energyReductionData?.consumption?.operational?.value || '-',
                    unit: energyReductionData?.consumption?.operational?.unit || '-',
                    remark: energyReductionData?.consumption?.operational?.remark || '-'
                  }
                ].filter(row => row.value !== '-' || row.unit !== '-' || row.remark !== '-') : []
                
                return (
                  <ReportTable
                    columns={reductionColumns}
                    rows={reductionRows}
                    showSerialNumber={true}
                  />
                )
              })()}
            </div>

            {/* Sub-section b: Types of energy included */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                b. Types of energy included in the reductions
              </p>
              <p className={styles.questionAnswer}>
                {energyReductionData?.includedReduction && energyReductionData.includedReduction.length > 0 ? energyReductionData.includedReduction.join(', ') : '-'}
              </p>
            </div>

            {/* Breakdown by energy type */}
            <div className={styles.questionBox}>
              {(() => {
                const energyTypeColumns = [
                  { field: 'energyType', label: 'Types of energy included in the reductions', width: '30%' },
                  { field: 'value', label: 'Value', width: '20%' },
                  { field: 'unit', label: 'Unit', width: '20%' },
                  { field: 'remark', label: 'Remark', width: '30%' }
                ]
                
                const energyTypeRows = energyReductionData?.reductionByEnergyType === 'Yes' && energyReductionData?.reductions ? [
                  {
                    energyType: 'Fuel (Petrol/Diesel or other)',
                    value: energyReductionData?.reductions?.fuel?.value || '-',
                    unit: energyReductionData?.reductions?.fuel?.unit || '-',
                    remark: energyReductionData?.reductions?.fuel?.remark || '-'
                  },
                  {
                    energyType: 'Electricity',
                    value: energyReductionData?.reductions?.electric?.value || '-',
                    unit: energyReductionData?.reductions?.electric?.unit || '-',
                    remark: energyReductionData?.reductions?.electric?.remark || '-'
                  },
                  {
                    energyType: 'Heating',
                    value: energyReductionData?.reductions?.heat?.value || '-',
                    unit: energyReductionData?.reductions?.heat?.unit || '-',
                    remark: energyReductionData?.reductions?.heat?.remark || '-'
                  },
                  {
                    energyType: 'Cooling',
                    value: energyReductionData?.reductions?.colling?.value || '-',
                    unit: energyReductionData?.reductions?.colling?.unit || '-',
                    remark: energyReductionData?.reductions?.colling?.remark || '-'
                  },
                  {
                    energyType: 'Steam',
                    value: energyReductionData?.reductions?.steam?.value || '-',
                    unit: energyReductionData?.reductions?.steam?.unit || '-',
                    remark: energyReductionData?.reductions?.steam?.remark || '-'
                  }
                ].filter(row => row.value !== '-' || row.unit !== '-' || row.remark !== '-') : []
                
                return (
                  <ReportTable
                    columns={energyTypeColumns}
                    rows={energyTypeRows}
                    showSerialNumber={true}
                  />
                )
              })()}
            </div>

            {/* Sub-section c: Basis for calculating reductions */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                c. Basis for calculating reductions in energy consumption, such as base year or baseline, including the rationale for choosing it.
              </p>
              <p className={styles.questionAnswer}>
                {energyReductionData?.basisReductionBasis || '-'}
              </p>
            </div>

            {/* Sub-section d: Standards and methodologies */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                d. Standards, methodologies, assumptions, and/or calculation tools used
              </p>
              <p className={styles.questionAnswer}>
                {energyReductionData?.standardsCalculation || '-'}
              </p>
            </div>
          </div>
        ) : (
          <div className={styles.consolidatingSection}>
            {/* Sub-section a: Amount of reductions */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. Amount of reductions in energy consumption achieved as a direct result of conservation and efficiency initiatives
              </p>
              <div className={styles.questionRow}>
                <span className={styles.questionLabel}>Total reduction in energy consumption:</span>
                <span className={styles.questionValue}>-</span>
              </div>
            </div>

            {/* Breakdown of reduction initiatives */}
            <div className={styles.questionBox}>
              <ReportTable
                columns={[
                  { field: 'initiative', label: 'Reduction initiatives', width: '30%' },
                  { field: 'value', label: 'Value', width: '20%' },
                  { field: 'unit', label: 'Unit', width: '20%' },
                  { field: 'remark', label: 'Remark', width: '30%' }
                ]}
                rows={[]}
                showSerialNumber={true}
              />
            </div>

            {/* Breakdown by energy type */}
            <div className={styles.questionBox}>
              <ReportTable
                columns={[
                  { field: 'energyType', label: 'Types of energy included in the reductions', width: '30%' },
                  { field: 'value', label: 'Value', width: '20%' },
                  { field: 'unit', label: 'Unit', width: '20%' },
                  { field: 'remark', label: 'Remark', width: '30%' }
                ]}
                rows={[]}
                showSerialNumber={true}
              />
            </div>
          </div>
        )}
      </div>

      {/* GRI 302-5 - Reductions in Energy Requirements of Products and Services */}
      <div className={styles.container}>
    
        <h1 className={styles.mainHeading}>
          302-5 : REDUCTIONS IN ENERGY REQUIREMENTS OF PRODUCTS AND SERVICES
        </h1>
        
        {energyRequirementsReductionData ? (
          <div className={styles.consolidatingSection}>
            {/* Sub-section a: Reductions achieved */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. What were the reductions in energy requirements of sold products and services achieved during the reporting period
              </p>
              <div className={styles.questionRow}>
                <span className={styles.questionLabel}>Amount:</span>
                <span className={styles.questionValue}>
                  {energyRequirementsReductionData?.energyReductionsAchieved?.amount || '-'}
                </span>
              </div>
              <div className={styles.questionRow}>
                <span className={styles.questionLabel}>Unit:</span>
                <span className={styles.questionValue}>
                  {energyRequirementsReductionData?.energyReductionsAchieved?.unit || '-'}
                </span>
              </div>
            </div>

            {/* Sub-section b: Basis for calculating reductions */}
            <div className={styles.questionBox}>
              <p className={`${`${styles.questionTitle} common_text_style`}`}>
                b. Basis for calculating reductions in energy consumption, such as base year or baseline, including the rationale for choosing it
              </p>
              <p className={styles.questionAnswer}>
                {energyRequirementsReductionData?.energyReductionBasis || '-'}
              </p>
            </div>

            {/* Sub-section c: Standards and methodologies */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                c. Standards, methodologies, assumptions, and/or calculation tools used.
              </p>
              <p className={styles.questionAnswer}>
                {energyRequirementsReductionData?.energyReductionMethodologies || '-'}
              </p>
            </div>
          </div>
        ) : (
          <div className={styles.consolidatingSection}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                -
              </p>
            </div>
          </div>
        )}
      </div>

      {/* GRI 303 - Water and Effluents */}
      <div className={styles.container}>
        <p className={styles.sectionHeading}>
          303: WATER & EFFLUENTS
        </p>
        
        {/* 303-1: Interactions with water as a shared resource */}
        <h1 className={styles.mainHeading}>
          303-1 : INTERACTIONS WITH WATER AS A SHARED RESOURCE
        </h1>
        
        {sharedResourceData ? (
            <div className={styles.consolidatingSection}>
              {/* Sub-section a: Interactions with water table */}
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  a. Interactions with water in kiloliters, including details on water withdrawal, consumption, discharge & water-related impacts
                </p>
                {(() => {
                  const interactionColumns = [
                    { field: 'interactions', label: 'Interactions In', width: '20%' },
                    { field: 'response', label: 'Response', width: '22%' },
                    { field: 'quntity', label: 'Quantity', width: '17%' },
                    { field: 'remark', label: 'Remark', width: '25%' }
                  ]
                  
                  const interactionRows = sharedResourceData?.waterInteraction && Array.isArray(sharedResourceData.waterInteraction) && sharedResourceData.waterInteraction.length > 0
                    ? sharedResourceData.waterInteraction.map((item) => ({
                        interactions: item?.interactions || '-',
                        response: item?.response || '-',
                        quntity: item?.quntity || '-',
                        remark: item?.remark || '-'
                      }))
                    : []
                  
                  return (
                    <ReportTable
                      columns={interactionColumns}
                      rows={interactionRows}
                      showSerialNumber={true}
                    />
                  )
                })()}
              </div>

              {/* Sub-section b: Water-related impacts approach */}
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  b. Describe the approach used to identify and assess water-related impacts, including the assessment scope, time period covered, and the tools or methodologies applied.
                </p>
                <p className={styles.questionAnswer}>
                  {sharedResourceData?.waterRelatedImpactsApproach || '-'}
                </p>
              </div>

              {/* Sub-section c: Water impact management */}
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  c. Describe how water-related impacts are addressed, including how the organization works with stakeholders to steward water as a shared resource, and how it engages with suppliers or customers with significant water-related impacts.
                </p>
                <p className={styles.questionAnswer}>
                  {sharedResourceData?.waterImpactManagementDescription || '-'}
                </p>
              </div>

              {/* Sub-section d: Water goals and targets */}
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  d. Explain the process for setting any water-related goals and targets that are part of the organization's approach to managing water and effluents, and how they relate to public policy and the local context of each area with water stress.
                </p>
                <p className={styles.questionAnswer}>
                  {sharedResourceData?.waterGoalsAndTargetsExplanation || '-'}
                </p>
              </div>
            </div>
          ) : (
            <div className={styles.consolidatingSection}>
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  a. Interactions with water in kiloliters, including details on water withdrawal, consumption, discharge & water-related impacts
                </p>
                <ReportTable
                  columns={[
                    { field: 'interactions', label: 'Interactions In', width: '20%' },
                    { field: 'response', label: 'Response', width: '22%' },
                    { field: 'quntity', label: 'Quantity', width: '17%' },
                    { field: 'remark', label: 'Remark', width: '25%' }
                  ]}
                  rows={[]}
                  showSerialNumber={true}
                />
              </div>
            </div>
          )}

          {/* 303-2: Management of water discharge related impacts */}
          <h1 className={styles.mainHeading}>
            303-2 : MANAGEMENT OF WATER DISCHARGE RELATED IMPACTS
          </h1>
          
          {waterManagementData ? (
            <div className={styles.consolidatingSection}>
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  a. Describe any minimum standards set for the quality of effluent discharge.
                </p>
                
                <div className={styles.questionBox}>
                  <p className={styles.subQuestionTitle}>
                    i. How were standards for facilities operating in locations with no local discharge requirements determined?
                  </p>
                  <p className={styles.questionAnswer}>
                    {waterManagementData?.operatingStandards || '-'}
                  </p>
                </div>

                <div className={styles.questionBox}>
                  <p className={styles.subQuestionTitle}>
                    ii. Were any internally developed water quality standards or guidelines considered? If so, please describe.
                  </p>
                  <p className={styles.questionAnswer}>
                    {waterManagementData?.internalWaterQualityStandards?.remark || '-'}
                  </p>
                </div>

                <div className={styles.questionBox}>
                  <p className={styles.subQuestionTitle}>
                    iii. Were any sector-specific standards considered? If yes, please specify.
                  </p>
                  <p className={styles.questionAnswer}>
                    {waterManagementData?.sectorSpecificStandards?.remark || '-'}
                  </p>
                </div>

                <div className={styles.questionBox}>
                  <p className={styles.subQuestionTitle}>
                    iv. Was the profile of the receiving water body considered when setting effluent discharge standards?
                  </p>
                  <p className={styles.questionAnswer}>
                    {waterManagementData?.waterBodyProfileConsidered?.remark || '-'}
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div className={styles.consolidatingSection}>
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  a. Describe any minimum standards set for the quality of effluent discharge.
                </p>
                <p className={styles.questionAnswer}>
                  -
                </p>
              </div>
            </div>
          )}

        {/* 303-3: Water withdrawal */}
        <h1 className={styles.mainHeading}>
          303-3 : WATER WITHDRAWAL
        </h1>
        
        {waterWithdrawalData ? (
            <div className={styles.consolidatingSection}>
              {/* Sub-section a: Total water withdrawal by destination */}
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  a. Total water withdrawal to all areas in kiloliters.
                </p>
                {(() => {
                  const withdrawalColumns = [
                    { field: 'destination', label: 'Destination', width: '18%' },
                    { field: 'response', label: 'Response', width: '20%' },
                    { field: 'quantity', label: 'Quantity', width: '15%' },
                    { field: 'remark', label: 'Remark', width: '25%' }
                  ]
                  
                  const withdrawalRows = waterWithdrawalData?.totalWaterWithdrawalByDestination && Array.isArray(waterWithdrawalData.totalWaterWithdrawalByDestination) && waterWithdrawalData.totalWaterWithdrawalByDestination.length > 0
                    ? waterWithdrawalData.totalWaterWithdrawalByDestination.map((item) => ({
                        destination: item?.destination || '-',
                        response: item?.response || '-',
                        quantity: item?.quantity || '-',
                        remark: item?.remark || '-'
                      }))
                    : []
                  
                  return (
                    <ReportTable
                      columns={withdrawalColumns}
                      rows={withdrawalRows}
                      showSerialNumber={true}
                    />
                  )
                })()}
              </div>

              {/* Sub-section b: Water withdrawal in water stress areas */}
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  b. Total water withdrawal from all areas with water stress in kiloliters
                </p>
                {(() => {
                  const stressColumns = [
                    { field: 'destination', label: 'Destination', width: '18%' },
                    { field: 'response', label: 'Response', width: '20%' },
                    { field: 'quantity', label: 'Quantity', width: '15%' },
                    { field: 'remark', label: 'Remark', width: '25%' }
                  ]
                  
                  const stressRows = waterWithdrawalData?.waterWithdrawalInWaterStressAreas && Array.isArray(waterWithdrawalData.waterWithdrawalInWaterStressAreas) && waterWithdrawalData.waterWithdrawalInWaterStressAreas.length > 0
                    ? waterWithdrawalData.waterWithdrawalInWaterStressAreas.map((item) => ({
                        destination: item?.destination || '-',
                        response: item?.response || '-',
                        quantity: item?.quantity || '-',
                        remark: item?.remark || '-'
                      }))
                    : []
                  
                  return (
                    <ReportTable
                      columns={stressColumns}
                      rows={stressRows}
                      showSerialNumber={true}
                    />
                  )
                })()}
              </div>

              {/* Sub-section c: Total by categories */}
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  c. Total of water withdrawal from each of the sources listed in 303-3-a and 303-3-b in kiloliters by following categories
                </p>
                {(() => {
                  const categoryColumns = [
                    { field: 'withdrawal', label: 'Water Withdrawal', width: '18%' },
                    { field: 'range', label: 'Range', width: '18%' },
                    { field: 'quantity', label: 'Quantity', width: '15%' },
                    { field: 'remark', label: 'Remark', width: '25%' }
                  ]
                  
                  const categoryRows = waterWithdrawalData?.allAreasWater && Array.isArray(waterWithdrawalData.allAreasWater) && waterWithdrawalData.allAreasWater.length > 0
                    ? waterWithdrawalData.allAreasWater.map((item) => ({
                        withdrawal: item?.withdrawal || '-',
                        range: item?.range || '-',
                        quantity: item?.quantity || '-',
                        remark: item?.remark || '-'
                      }))
                    : []
                  
                  return (
                    <ReportTable
                      columns={categoryColumns}
                      rows={categoryRows}
                      showSerialNumber={true}
                    />
                  )
                })()}
              </div>

              {/* Sub-section d: Contextual information */}
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  d. Provide contextual information necessary to understand how the data have been compiled, such as any standards, methodologies, and assumptions used.
                </p>
                <p className={styles.questionAnswer}>
                  {waterWithdrawalData?.contextualInformation || '-'}
                </p>
              </div>
            </div>
          ) : (
            <div className={styles.consolidatingSection}>
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  a. Total water withdrawal to all areas in kiloliters.
                </p>
                <ReportTable
                  columns={[
                    { field: 'destination', label: 'Destination', width: '18%' },
                    { field: 'response', label: 'Response', width: '20%' },
                    { field: 'quantity', label: 'Quantity', width: '15%' },
                    { field: 'remark', label: 'Remark', width: '25%' }
                  ]}
                  rows={[]}
                  showSerialNumber={true}
                />
              </div>
            </div>
          )}

        {/* 303-4: Water discharge */}
        <h1 className={styles.mainHeading}>
          303-4 : WATER DISCHARGE
        </h1>
        
        {waterDischargeData ? (
            <div className={styles.consolidatingSection}>
              {/* Sub-section a: Total water discharge by destination */}
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  a. Total water discharge to all areas in kiloliters.
                </p>
                <div className={styles.questionRow}>
                  <span className={styles.questionLabel}>Total:</span>
                  <span className={styles.questionValue}>
                    {waterDischargeData?.totalWaterAllareas?.total || '-'}
                  </span>
                </div>
                <p className={`${styles.questionTitle} common_text_style`} style={{ marginTop: '1rem' }}>
                  Breakdown of total water discharge in kiloliters by the following types of destination (include all facility)
                </p>
                {(() => {
                  const dischargeColumns = [
                    { field: 'destination', label: 'Destination', width: '22%' },
                    { field: 'response', label: 'Response', width: '18%' },
                    { field: 'quantity', label: 'Quantity', width: '15%' },
                    { field: 'remark', label: 'Remark', width: '15%' }
                  ]
                  
                  const dischargeRows = waterDischargeData?.totalWaterAllareas?.totalWaterDischargeByDestination && Array.isArray(waterDischargeData.totalWaterAllareas.totalWaterDischargeByDestination) && waterDischargeData.totalWaterAllareas.totalWaterDischargeByDestination.length > 0
                    ? waterDischargeData.totalWaterAllareas.totalWaterDischargeByDestination.map((item) => ({
                        destination: item?.destination || '-',
                        response: item?.response || '-',
                        quantity: item?.quantity || '-',
                        remark: item?.remark || '-'
                      }))
                    : []
                  
                  return (
                    <ReportTable
                      columns={dischargeColumns}
                      rows={dischargeRows}
                      showSerialNumber={true}
                    />
                  )
                })()}
              </div>

              {/* Sub-section b: Water discharge by category */}
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  b. Breakdown of total water discharge to all areas in kiloliters by the following categories:
                </p>
                {(() => {
                  const categoryColumns = [
                    { field: 'waterType', label: 'Water Withdrawal', width: '18%' },
                    { field: 'range', label: 'Range', width: '18%' },
                    { field: 'response', label: 'Response', width: '18%' },
                    { field: 'quantity', label: 'Quantity', width: '15%' },
                    { field: 'remark', label: 'Remark', width: '15%' }
                  ]
                  
                  const categoryRows = waterDischargeData?.waterDischargeByCategory && Array.isArray(waterDischargeData.waterDischargeByCategory) && waterDischargeData.waterDischargeByCategory.length > 0
                    ? waterDischargeData.waterDischargeByCategory.map((item) => ({
                        waterType: item?.waterType || '-',
                        range: item?.range || '-',
                        response: item?.response || '-',
                        quantity: item?.quantity || '-',
                        remark: item?.remark || '-'
                      }))
                    : []
                  
                  return (
                    <ReportTable
                      columns={categoryColumns}
                      rows={categoryRows}
                      showSerialNumber={true}
                    />
                  )
                })()}
              </div>

              {/* Sub-section c: Water discharge to water stress areas */}
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  c. Total water discharge to all areas with water stress in kiloliters
                </p>
                <div className={styles.questionRow}>
                  <span className={styles.questionLabel}>Total:</span>
                  <span className={styles.questionValue}>
                    {waterDischargeData?.waterDischargeToWaterStressAreas?.total || '-'}
                  </span>
                </div>
                <p className={`${styles.questionTitle} common_text_style`} style={{ marginTop: '1rem' }}>
                  Breakdown of total water discharge to areas with water stress in kiloliters by the following categories:
                </p>
                {(() => {
                  const stressColumns = [
                    { field: 'waterType', label: 'Water Withdrawal', width: '18%' },
                    { field: 'range', label: 'Range', width: '18%' },
                    { field: 'response', label: 'Response', width: '18%' },
                    { field: 'quantity', label: 'Quantity', width: '15%' },
                    { field: 'remark', label: 'Remark', width: '15%' }
                  ]
                  
                  const stressRows = waterDischargeData?.waterDischargeToWaterStressAreas?.table && Array.isArray(waterDischargeData.waterDischargeToWaterStressAreas.table) && waterDischargeData.waterDischargeToWaterStressAreas.table.length > 0
                    ? waterDischargeData.waterDischargeToWaterStressAreas.table.map((item) => ({
                        waterType: item?.waterType || '-',
                        range: item?.range || '-',
                        response: item?.response || '-',
                        quantity: item?.quantity || '-',
                        remark: item?.remark || '-'
                      }))
                    : []
                  
                  return (
                    <ReportTable
                      columns={stressColumns}
                      rows={stressRows}
                      showSerialNumber={true}
                    />
                  )
                })()}
              </div>

              {/* Sub-section d: Checklist for priority substances */}
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  d. Checklist for priority substances of concern in discharges:
                </p>
                
                <div className={styles.questionBox}>
                  <p className={styles.subQuestionTitle}>
                    i. How were priority substances of concern defined, and were any international standards, authoritative lists, or criteria used?
                  </p>
                  <p className={styles.questionAnswer}>
                    {waterDischargeData?.checklistForPriority?.prioritySubstancesDefinitionCriteria || '-'}
                  </p>
                </div>

                <div className={styles.questionBox}>
                  <p className={styles.subQuestionTitle}>
                    ii. What approach was taken for setting discharge limits for priority substances of concern?
                  </p>
                  <p className={styles.questionAnswer}>
                    {waterDischargeData?.checklistForPriority?.dischargeLimitsSettingApproach || '-'}
                  </p>
                </div>

                <div className={styles.questionBox}>
                  <p className={styles.subQuestionTitle}>
                    iii. How many incidents of non-compliance with discharge limits occurred during the reporting period?
                  </p>
                  <p className={styles.questionAnswer}>
                    {waterDischargeData?.checklistForPriority?.nonComplianceIncidentsDuring || '-'}
                  </p>
                </div>
              </div>

              {/* Sub-section e: Contextual information */}
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  e. Provide any contextual information necessary for understanding how the data have been compiled, including details about the standards, methodologies, and assumptions used.
                </p>
                <p className={styles.questionAnswer}>
                  {waterDischargeData?.contextualInformation || '-'}
                </p>
              </div>
            </div>
          ) : (
            <div className={styles.consolidatingSection}>
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  a. Total water discharge to all areas in kiloliters.
                </p>
                <ReportTable
                  columns={[
                    { field: 'destination', label: 'Destination', width: '22%' },
                    { field: 'response', label: 'Response', width: '18%' },
                    { field: 'quantity', label: 'Quantity', width: '15%' },
                    { field: 'remark', label: 'Remark', width: '15%' }
                  ]}
                  rows={[]}
                  showSerialNumber={true}
                />
              </div>
            </div>
          )}

        {/* 303-5: Water consumption */}
        <h1 className={styles.mainHeading}>
          303-5 : WATER CONSUMPTION
        </h1>
        
        {waterConsumptionData ? (
            <div className={styles.consolidatingSection}>
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  i. Total water consumption from all areas in kiloliters.
                </p>
                <p className={styles.questionAnswer}>
                  {waterConsumptionData?.totalConsumption || '-'}
                </p>
              </div>

              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  ii. Total water consumption from all areas with water stress in kiloliters.
                </p>
                <p className={styles.questionAnswer}>
                  {waterConsumptionData?.totalConsumptionWaterStress || '-'}
                </p>
              </div>

              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  iii. Change in water storage in kiloliters, if significant water-related impacts have been identified.
                </p>
                <p className={styles.questionAnswer}>
                  {waterConsumptionData?.changeInWaterStorage || '-'}
                </p>
              </div>

              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  iv. Provide any contextual information necessary to understand how the data have been compiled, including details about the standards, methodologies, and assumptions used. This includes specifying if the information is calculated, estimated, modelled, or sourced from direct measurements, and the approach taken for this, such as the utilization of any sector-specific factors.
                </p>
                <p className={styles.questionAnswer}>
                  {waterConsumptionData?.contextualInformation || '-'}
                </p>
              </div>
            </div>
          ) : (
            <div className={styles.consolidatingSection}>
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  i. Total water consumption from all areas in kiloliters.
                </p>
                <p className={styles.questionAnswer}>
                  -
                </p>
              </div>
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  ii. Total water consumption from all areas with water stress in kiloliters.
                </p>
                <p className={styles.questionAnswer}>
                  -
                </p>
              </div>
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  iii. Change in water storage in kiloliters, if significant water-related impacts have been identified.
                </p>
                <p className={styles.questionAnswer}>
                  -
                </p>
              </div>
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  iv. Provide any contextual information necessary to understand how the data have been compiled, including details about the standards, methodologies, and assumptions used. This includes specifying if the information is calculated, estimated, modelled, or sourced from direct measurements, and the approach taken for this, such as the utilization of any sector-specific factors.
                </p>
                <p className={styles.questionAnswer}>
                  -
                </p>
              </div>
            </div>
          )}
        </div>

      {/* GRI 304 - Biodiversity */}
      <div className={styles.container}>
        <p className={styles.sectionHeading}>
          304: BIODIVERSITY
        </p>
        
        {/* 304-1: Operational sites owned, leased, managed in, or adjacent to, protected areas and areas of high biodiversity value */}
        <h1 className={styles.mainHeading}>
          304-1 : OPERATIONAL SITES OWNED, LEASED, MANAGED IN, OR ADJACENT TO, PROTECTED AREAS AND AREAS OF HIGH BIODIVERSITY VALUE
        </h1>
        
        {operationalSitesBiodiversityData && Array.isArray(operationalSitesBiodiversityData) && operationalSitesBiodiversityData.length > 0 ? (
          <div className={styles.consolidatingSection}>
            <p className={`${styles.consolidatingTitle} common_text_style`}>
              a. Could you please provide details for each operational site that is either owned, leased, managed within, or located adjacent to protected areas, as well as areas of high biodiversity value that are outside protected areas?
            </p>
            
            {operationalSitesBiodiversityData.map((site, index) => (
              <div key={index} className={styles.questionBox}>
                <p className={styles.productName}>
                  Operational Site: {site?.operationalSite || 'Unnamed Site'}
                </p>
                
                <div className={styles.questionsContainer}>
                  {/* Section 1: Location Details */}
                  <p className={`${styles.questionTitle} common_text_style`}>
                    1. Location Details:
                  </p>
                  <div className={styles.questionRow}>
                    <span className={styles.questionLabel}>Country:</span>
                    <span className={styles.questionValue}>{site?.locationDetails?.country || '-'}</span>
                  </div>
                  <div className={styles.questionRow}>
                    <span className={styles.questionLabel}>Region:</span>
                    <span className={styles.questionValue}>{site?.locationDetails?.region || '-'}</span>
                  </div>
                  <div className={styles.questionRow}>
                    <span className={styles.questionLabel}>Locality:</span>
                    <span className={styles.questionValue}>{site?.locationDetails?.locality || '-'}</span>
                  </div>
                  
                  {/* Section 2: Land Ownership and Management */}
                  <p className={`${styles.questionTitle} common_text_style`}>
                    2. Land Ownership and Management:
                  </p>
                  <div className={styles.questionRow}>
                    <span className={styles.questionLabel}>Subsurface and Underground Land Status:</span>
                    <span className={styles.questionValue}>{site?.landOwernship || '-'}</span>
                  </div>
                  
                  {/* Section 3: Relationship to Protected Areas */}
                  <p className={`${styles.questionTitle} common_text_style`}>
                    3. Relationship to Protected Areas or High Biodiversity Value Areas:
                  </p>
                  <div className={styles.questionRow}>
                    <span className={styles.questionLabel}>Proximity to protected areas (inside, adjacent to, or containing portions of):</span>
                    <span className={styles.questionValue}>{site?.highBiodiversity?.proximity || '-'}</span>
                  </div>
                  <div className={styles.questionRow}>
                    <span className={styles.questionLabel}>Relation to high biodiversity value areas outside protected zones:</span>
                    <span className={styles.questionValue}>{site?.highBiodiversity?.outsideZones || '-'}</span>
                  </div>
                  
                  {/* Section 4: Operational Site Type */}
                  <p className={`${styles.questionTitle} common_text_style`}>
                    4. Operational Site Type:
                  </p>
                  <div className={styles.questionRow}>
                    <span className={styles.questionLabel}>Nature of Operation:</span>
                    <span className={styles.questionValue}>{site?.operationalSiteType || '-'}</span>
                  </div>
                  
                  {/* Section 5: Site Area */}
                  <p className={`${styles.questionTitle} common_text_style`}>
                    5. Site Area:
                  </p>
                  <div className={styles.questionRow}>
                    <span className={styles.questionLabel}>Size of operational site in square kilometers:</span>
                    <span className={styles.questionValue}>{site?.siteArea || '-'}</span>
                  </div>
                  
                  {/* Section 6: Biodiversity Characteristics */}
                  <p className={`${styles.questionTitle} common_text_style`}>
                    6. Biodiversity Characteristics:
                  </p>
                  <div className={styles.questionRow}>
                    <span className={styles.questionLabel}>Ecosystem Type:</span>
                    <span className={styles.questionValue}>{site?.characteristics?.ecosystem || site?.characteristics?.ecosytem || '-'}</span>
                  </div>
                  <div className={styles.questionRow}>
                    <span className={styles.questionLabel}>Key Biodiversity Attributes:</span>
                    <span className={styles.questionValue}>{site?.characteristics?.attributes || '-'}</span>
                  </div>
                  
                  {/* Section 7: Designation Frameworks */}
                  <p className={`${styles.questionTitle} common_text_style`}>
                    7. Designation under relevant conservation frameworks (IUCN Protected Area Management Categories, Ramsar Convention, national legislation):
                  </p>
                  <div className={styles.questionRow}>
                    <span className={styles.questionLabel}></span>
                    <span className={styles.questionValue}>{site?.desingationFrameworks || '-'}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className={styles.consolidatingSection}>
            <p className={`${styles.consolidatingTitle} common_text_style`}>
              a. Could you please provide details for each operational site that is either owned, leased, managed within, or located adjacent to protected areas, as well as areas of high biodiversity value that are outside protected areas?
            </p>
            <div className={styles.questionsContainer}>
              <div className={styles.questionBox}>
                <p className={styles.questionAnswer}>
                  -
                </p>
              </div>
            </div>
          </div>
        )}

        {/* 304-2: Significant impacts of activities, products and services on biodiversity */}
        <h1 className={styles.mainHeading}>
          304-2 : SIGNIFICANT IMPACTS OF ACTIVITIES, PRODUCTS AND SERVICES ON BIODIVERSITY
        </h1>
        
        {significantImpactsData ? (
          <div className={styles.consolidatingSection}>
            {/* Sub-section a: Nature of impact */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. Define the nature of significant direct and indirect impacts on biodiversity with reference to the following:
              </p>
              
              <div className={styles.questionBox}>
                <p className={styles.subQuestionTitle}>
                  i. Construction or utilization of manufacturing plants, mines, and transport infrastructure.
                </p>
                <p className={styles.questionAnswer}>
                  {significantImpactsData?.natureOfImpact?.constructions || '-'}
                </p>
              </div>

              <div className={styles.questionBox}>
                <p className={styles.subQuestionTitle}>
                  ii. Pollution: Describe the introduction of substances that do not naturally occur in the habitat, considering both point and non-point sources.
                </p>
                <p className={styles.questionAnswer}>
                  {significantImpactsData?.natureOfImpact?.pollution || '-'}
                </p>
              </div>

              <div className={styles.questionBox}>
                <p className={styles.subQuestionTitle}>
                  iii. Introduction of invasive species, pests, and pathogens.
                </p>
                <p className={styles.questionAnswer}>
                  {significantImpactsData?.natureOfImpact?.introductionOfInvasives || '-'}
                </p>
              </div>

              <div className={styles.questionBox}>
                <p className={styles.subQuestionTitle}>
                  iv. Reduction of species: Assess any observed decline in species abundance or diversity.
                </p>
                <p className={styles.questionAnswer}>
                  {significantImpactsData?.natureOfImpact?.reduction || '-'}
                </p>
              </div>

              <div className={styles.questionBox}>
                <p className={styles.subQuestionTitle}>
                  v. Habitat conversion: Identify any activities leading to the conversion of habitats (e.g., deforestation, wetland draining).
                </p>
                <p className={styles.questionAnswer}>
                  {significantImpactsData?.natureOfImpact?.habitatConversion || '-'}
                </p>
              </div>

              <div className={styles.questionBox}>
                <p className={styles.subQuestionTitle}>
                  vi. Changes in ecological processes outside the natural range of variation (e.g., alterations in salinity, groundwater levels).
                </p>
                <p className={styles.questionAnswer}>
                  {significantImpactsData?.natureOfImpact?.ecologicalProcess || '-'}
                </p>
              </div>
            </div>

            {/* Sub-section b: Positive or negative impact */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                b. Define significant direct and indirect positive and negative impacts with reference to the following:
              </p>
              
              <div className={styles.questionBox}>
                <p className={styles.subQuestionTitle}>
                  i. Which species are affected by the identified impacts?
                </p>
                <p className={styles.questionAnswer}>
                  {significantImpactsData?.positiveorNegativeImpact?.spceciesAffected || '-'}
                </p>
              </div>

              <div className={styles.questionBox}>
                <p className={styles.subQuestionTitle}>
                  ii. What is the extent of the impacted areas as a result of the identified impacts?
                </p>
                <p className={styles.questionAnswer}>
                  {significantImpactsData?.positiveorNegativeImpact?.extendImpacts || '-'}
                </p>
              </div>

              <div className={styles.questionBox}>
                <p className={styles.subQuestionTitle}>
                  iii. How long do the impacts persist or affect the environment?
                </p>
                <p className={styles.questionAnswer}>
                  {significantImpactsData?.positiveorNegativeImpact?.impactPersist || '-'}
                </p>
              </div>

              <div className={styles.questionBox}>
                <p className={styles.subQuestionTitle}>
                  iv. Are the identified impacts reversible, or are they irreversible in nature?
                </p>
                <p className={styles.questionAnswer}>
                  {significantImpactsData?.positiveorNegativeImpact?.reversible || '-'}
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.consolidatingSection}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                -
              </p>
            </div>
          </div>
        )}

        {/* 304-3: Habitats protected or restored */}
        <h1 className={styles.mainHeading}>
          304-3 : HABITATS PROTECTED OR RESTORED
        </h1>
        
        {habitatsProtectedData ? (
          <div className={styles.consolidatingSection}>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. What is the size and location of all habitat areas protected or restored, and whether the success of the restoration measure was or is approved by independent external professionals.
              </p>
              <p className={styles.questionAnswer}>
                {habitatsProtectedData?.habitatStatus || '-'}
              </p>
            </div>

            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                b. Does the organization have partnerships with third parties specifically aimed at protecting or restoring habitat areas separate from those where the organization directly oversees and implements restoration or protection measures?
              </p>
              <p className={styles.questionAnswer}>
                {habitatsProtectedData?.habitatPartnerships || '-'}
              </p>
            </div>

            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                c. What is the status of each habitat area based on its condition at the close of the reporting period?
              </p>
              <p className={styles.questionAnswer}>
                {habitatsProtectedData?.habitatAreaStatus || '-'}
              </p>
            </div>

            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                d. What standards, methodologies, and assumptions were utilized in determining the size, location, and status of habitat areas, as well as in the implementation of protection and restoration measures?
              </p>
              <p className={styles.questionAnswer}>
                {habitatsProtectedData?.habitatDataMethodologies || '-'}
              </p>
            </div>
          </div>
        ) : (
          <div className={styles.consolidatingSection}>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. What is the size and location of all habitat areas protected or restored, and whether the success of the restoration measure was or is approved by independent external professionals.
              </p>
              <p className={styles.questionAnswer}>
                -
              </p>
            </div>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                b. Does the organization have partnerships with third parties specifically aimed at protecting or restoring habitat areas separate from those where the organization directly oversees and implements restoration or protection measures?
              </p>
              <p className={styles.questionAnswer}>
                -
              </p>
            </div>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                c. What is the status of each habitat area based on its condition at the close of the reporting period?
              </p>
              <p className={styles.questionAnswer}>
                -
              </p>
            </div>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                d. What standards, methodologies, and assumptions were utilized in determining the size, location, and status of habitat areas, as well as in the implementation of protection and restoration measures?
              </p>
              <p className={styles.questionAnswer}>
                -
              </p>
            </div>
          </div>
        )}

        {/* 304-4: IUCN Red List species and national conservation list species */}
        <h1 className={styles.mainHeading}>
          304-4 : IUCN RED LIST SPECIES AND NATIONAL CONSERVATION LIST SPECIES WITH HABITATS IN AREAS AFFECTED BY OPERATIONS
        </h1>
        
        {iucnRedListConservationSpeciesData ? (
          <div className={styles.consolidatingSection}>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. How many IUCN Red List species and national conservation list species with habitats in areas affected by the operations of the organization were identified?
              </p>
              
              <div className={styles.questionRow}>
                <span className={styles.questionLabel}>Total number of Species Affected:</span>
                <span className={styles.questionValue}>
                  {iucnRedListConservationSpeciesData?.conservationSpeciesCount || '-'}
                </span>
              </div>

              <p className={`${styles.questionTitle} common_text_style`} style={{ marginTop: '1rem' }}>
                Level of Extinction Risk
              </p>
              <p className={styles.subQuestionTitle}>
                For each affected species, categorize the level of extinction risk based on the following classifications:
              </p>
              
              {(() => {
                const extinctionColumns = [
                  { field: 'destination', label: 'Destination', width: '50%' },
                  { field: 'numbers', label: 'Numbers', width: '50%' }
                ]
                
                const extinctionRows = iucnRedListConservationSpeciesData?.levelofExtinction && Array.isArray(iucnRedListConservationSpeciesData.levelofExtinction) && iucnRedListConservationSpeciesData.levelofExtinction.length > 0
                  ? iucnRedListConservationSpeciesData.levelofExtinction.map((item) => ({
                      destination: item?.destination || '-',
                      numbers: item?.numbers || '-'
                    }))
                  : [
                      { destination: 'Critically Endangered', numbers: '-' },
                      { destination: 'Endangered', numbers: '-' },
                      { destination: 'Vulnerable', numbers: '-' },
                      { destination: 'Near Threatened', numbers: '-' },
                      { destination: 'Least Concern', numbers: '-' }
                    ]
                
                return (
                  <ReportTable
                    columns={extinctionColumns}
                    rows={extinctionRows}
                    showSerialNumber={true}
                  />
                )
              })()}
            </div>
          </div>
        ) : (
          <div className={styles.consolidatingSection}>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. How many IUCN Red List species and national conservation list species with habitats in areas affected by the operations of the organization were identified?
              </p>
              <div className={styles.questionRow}>
                <span className={styles.questionLabel}>Total number of Species Affected:</span>
                <span className={styles.questionValue}>-</span>
              </div>
              <p className={`${styles.questionTitle} common_text_style`} style={{ marginTop: '1rem' }}>
                Level of Extinction Risk
              </p>
              <ReportTable
                columns={[
                  { field: 'destination', label: 'Destination', width: '50%' },
                  { field: 'numbers', label: 'Numbers', width: '50%' }
                ]}
                rows={[
                  { destination: 'Critically Endangered', numbers: '-' },
                  { destination: 'Endangered', numbers: '-' },
                  { destination: 'Vulnerable', numbers: '-' },
                  { destination: 'Near Threatened', numbers: '-' },
                  { destination: 'Least Concern', numbers: '-' }
                ]}
                showSerialNumber={true}
              />
            </div>
          </div>
        )}
      </div>

      

      {/* GRI 305 - Emissions */}
      <div className={styles.container}>
        <p className={styles.sectionHeading}>
          305: EMISSIONS
        </p>
        
        {/* 305-1: Direct (Scope 1) GHG emissions */}
        <h1 className={styles.mainHeading}>
          305-1 : DIRECT (SCOPE 1) GHG EMISSIONS
        </h1>
        
        {scope1EmissionsData ? (
          <div className={styles.consolidatingSection}>
            {/* Sub-section a: Total Scope 1 emissions */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. What is the total amount of greenhouse gas emissions in metric tons of CO2 equivalent emitted directly (Scope 1 emissions) by the organization?
              </p>
              <p className={styles.questionAnswer}>
                {scope1EmissionsData?.scope1EmissionsTotal || '-'}
              </p>
            </div>

            {/* Sub-section b: Gases included */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                b. Gases included in the calculation:
              </p>
              {(() => {
                const gasesColumns = [
                  { field: 'gasName', label: 'Gas Name', width: '50%' },
                  { field: 'total', label: 'Total Emission', width: '50%' }
                ]
                
                const gasesRows = scope1EmissionsData?.emissionsGasesIncluded && Array.isArray(scope1EmissionsData.emissionsGasesIncluded) && scope1EmissionsData.emissionsGasesIncluded.length > 0
                  ? scope1EmissionsData.emissionsGasesIncluded.map((item) => ({
                      gasName: item?.gasName || '-',
                      total: item?.total || '-'
                    }))
                  : [
                      { gasName: 'CO2', total: '-' },
                      { gasName: 'CH4', total: '-' },
                      { gasName: 'N2O', total: '-' },
                      { gasName: 'HFCs', total: '-' },
                      { gasName: 'PFCs', total: '-' },
                      { gasName: 'SF6', total: '-' },
                      { gasName: 'NF3', total: '-' }
                    ]
                
                return (
                  <ReportTable
                    columns={gasesColumns}
                    rows={gasesRows}
                    showSerialNumber={true}
                  />
                )
              })()}
            </div>

            {/* Sub-section c: Biogenic CO2 emissions */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                c. What is the biogenic CO2 emissions in metric tons of CO2 equivalent?
              </p>
              <p className={styles.questionAnswer}>
                {scope1EmissionsData?.biogenicCO2Emissions || '-'}
              </p>
            </div>

            {/* Sub-section d: Base year */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                d. If applicable, define base year for the calculation:
              </p>
              
              <div className={styles.questionBox}>
                <p className={styles.subQuestionTitle}>
                  i. The rationale behind the selection of the base year.
                </p>
                <p className={styles.questionAnswer}>
                  {scope1EmissionsData?.baseYearEmissionData?.rationaleBehind || '-'}
                </p>
              </div>

              <div className={styles.questionBox}>
                <p className={styles.subQuestionTitle}>
                  ii. The total emissions recorded in the base year.
                </p>
                <p className={styles.questionAnswer}>
                  {scope1EmissionsData?.baseYearEmissionData?.totalEmission || '-'}
                </p>
              </div>

              <div className={styles.questionBox}>
                <p className={styles.subQuestionTitle}>
                  iii. Provide context for any significant changes in emissions that prompted the recalculation of base year emissions.
                </p>
                <p className={styles.questionAnswer}>
                  {scope1EmissionsData?.baseYearEmissionData?.recalculationBaseYear || '-'}
                </p>
              </div>
            </div>

            {/* Sub-section e: Emission factors */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                e. What is the source of the emission factors and global warming potential (GWP) rates used in emissions calculations? Provide references to the source if available.
              </p>
              <p className={styles.questionAnswer}>
                {scope1EmissionsData?.emissionFactorsGWPReferences || '-'}
              </p>
            </div>

            {/* Sub-section f: Consolidation method */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                f. How are emissions consolidated? Specify whether equity share, financial control, or operational control is utilized for consolidation purposes.
              </p>
              <p className={styles.questionAnswer}>
                {scope1EmissionsData?.emissionsConsolidationMethod || '-'}
              </p>
            </div>

            {/* Sub-section g: Calculation methods */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                g. What standards, methodologies, assumptions, and/or calculation tools were utilized in emissions calculations?
              </p>
              <p className={styles.questionAnswer}>
                {scope1EmissionsData?.emissionsCalculationMethods || '-'}
              </p>
            </div>
          </div>
        ) : (
          <div className={styles.consolidatingSection}>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. What is the total amount of greenhouse gas emissions in metric tons of CO2 equivalent emitted directly (Scope 1 emissions) by the organization?
              </p>
              <p className={styles.questionAnswer}>
                -
              </p>
            </div>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                b. Gases included in the calculation:
              </p>
              <ReportTable
                columns={[
                  { field: 'gasName', label: 'Gas Name', width: '50%' },
                  { field: 'total', label: 'Total Emission', width: '50%' }
                ]}
                rows={[
                  { gasName: 'CO2', total: '-' },
                  { gasName: 'CH4', total: '-' },
                  { gasName: 'N2O', total: '-' },
                  { gasName: 'HFCs', total: '-' },
                  { gasName: 'PFCs', total: '-' },
                  { gasName: 'SF6', total: '-' },
                  { gasName: 'NF3', total: '-' }
                ]}
                showSerialNumber={true}
              />
            </div>
          </div>
        )}

        {/* 305-2: Energy indirect (Scope 2) GHG emissions */}
        <h1 className={styles.mainHeading}>
          305-2 : ENERGY INDIRECT (SCOPE 2) GHG EMISSIONS
        </h1>
        
        {scope2EmissionsData ? (
          <div className={styles.consolidatingSection}>
            {/* Sub-section a: Total Scope 2 emissions */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. What is the total amount of greenhouse gas emissions in metric tons of CO2 equivalent emitted directly (Scope 2 emissions) by the organization?
              </p>
              <p className={styles.questionAnswer}>
                {scope2EmissionsData?.total || '-'}
              </p>
            </div>

            {/* Country-wise emissions */}
            {scope2EmissionsData?.countryEmission && Array.isArray(scope2EmissionsData.countryEmission) && scope2EmissionsData.countryEmission.length > 0 && (
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  If available, provide Scope 2 emission country wise.
                </p>
                {(() => {
                  const countryColumns = [
                    { field: 'country', label: 'Country', width: '50%' },
                    { field: 'value', label: 'Value (tCO2e)', width: '50%' }
                  ]
                  
                  const countryRows = scope2EmissionsData.countryEmission.map((item) => ({
                    country: item?.country || '-',
                    value: item?.value || '-'
                  }))
                  
                  return (
                    <ReportTable
                      columns={countryColumns}
                      rows={countryRows}
                      showSerialNumber={true}
                    />
                  )
                })()}
              </div>
            )}

            {/* Sub-section b: Marked-based energy indirect emissions */}
            {scope2EmissionsData?.biogenicCO2Emissions && Array.isArray(scope2EmissionsData.biogenicCO2Emissions) && scope2EmissionsData.biogenicCO2Emissions.length > 0 && (
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  b. Total gross marked-based energy indirect (Scope 2) GHG Emissions
                </p>
                {(() => {
                  const markedColumns = [
                    { field: 'emission', label: 'Emission', width: '30%' },
                    { field: 'value', label: 'Value', width: '30%' },
                    { field: 'unit', label: 'Unit', width: '30%' }
                  ]
                  
                  const markedRows = scope2EmissionsData.biogenicCO2Emissions.map((item) => ({
                    emission: item?.emission || '-',
                    value: item?.value || '-',
                    unit: item?.unit || '-'
                  }))
                  
                  return (
                    <ReportTable
                      columns={markedColumns}
                      rows={markedRows}
                      showSerialNumber={true}
                    />
                  )
                })()}
              </div>
            )}

            {/* Sub-section c: Gases included */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                c. Gases included in the calculation:
              </p>
              {(() => {
                const gasesColumns = [
                  { field: 'gasName', label: 'Gas Name', width: '50%' },
                  { field: 'total', label: 'Total Emission', width: '50%' }
                ]
                
                const gasesRows = scope2EmissionsData?.gasesIncluded && Array.isArray(scope2EmissionsData.gasesIncluded) && scope2EmissionsData.gasesIncluded.length > 0
                  ? scope2EmissionsData.gasesIncluded.map((item) => ({
                      gasName: item?.gasName || '-',
                      total: item?.total || '-'
                    }))
                  : [
                      { gasName: 'CO2', total: '-' },
                      { gasName: 'CH4', total: '-' },
                      { gasName: 'N2O', total: '-' },
                      { gasName: 'HFCs', total: '-' },
                      { gasName: 'PFCs', total: '-' },
                      { gasName: 'SF6', total: '-' },
                      { gasName: 'NF3', total: '-' }
                    ]
                
                return (
                  <ReportTable
                    columns={gasesColumns}
                    rows={gasesRows}
                    showSerialNumber={true}
                  />
                )
              })()}
            </div>

            {/* Sub-section d: Base year */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                d. If applicable, define base year for the calculation:
              </p>
              
              <div className={styles.questionBox}>
                <p className={styles.subQuestionTitle}>
                  i. The rationale behind the selection of the base year.
                </p>
                <p className={styles.questionAnswer}>
                  {scope2EmissionsData?.baseYearEmissionData?.rationaleBehind || '-'}
                </p>
              </div>

              <div className={styles.questionBox}>
                <p className={styles.subQuestionTitle}>
                  ii. Emission in metric tons of CO2 Equivalent.
                </p>
                <p className={styles.questionAnswer}>
                  {scope2EmissionsData?.baseYearEmissionData?.totalEmission || '-'}
                </p>
              </div>

              <div className={styles.questionBox}>
                <p className={styles.subQuestionTitle}>
                  iii. Provide context for any significant changes in emissions that prompted the recalculation of base year emissions.
                </p>
                <p className={styles.questionAnswer}>
                  {scope2EmissionsData?.baseYearEmissionData?.recalculationBaseYear || '-'}
                </p>
              </div>
            </div>

            {/* Sub-section e: Emission factors */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                e. What is the source of the emission factors and global warming potential (GWP) rates used in emissions calculations? Provide references to the source if available.
              </p>
              <p className={styles.questionAnswer}>
                {scope2EmissionsData?.emissionFactorsGWPReferences || '-'}
              </p>
            </div>

            {/* Sub-section f: Consolidation method */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                f. How are emissions consolidated? Specify whether equity share, financial control, or operational control is utilized for consolidation purposes.
              </p>
              <p className={styles.questionAnswer}>
                {scope2EmissionsData?.emissionsConsolidationMethod || '-'}
              </p>
            </div>

            {/* Sub-section g: Calculation methods */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                g. What standards, methodologies, assumptions, and/or calculation tools were utilized in emissions calculations?
              </p>
              <p className={styles.questionAnswer}>
                {scope2EmissionsData?.emissionsCalculationMethods || '-'}
              </p>
            </div>
          </div>
        ) : (
          <div className={styles.consolidatingSection}>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. What is the total amount of greenhouse gas emissions in metric tons of CO2 equivalent emitted directly (Scope 2 emissions) by the organization?
              </p>
              <p className={styles.questionAnswer}>
                -
              </p>
            </div>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                c. Gases included in the calculation:
              </p>
              <ReportTable
                columns={[
                  { field: 'gasName', label: 'Gas Name', width: '50%' },
                  { field: 'total', label: 'Total Emission', width: '50%' }
                ]}
                rows={[
                  { gasName: 'CO2', total: '-' },
                  { gasName: 'CH4', total: '-' },
                  { gasName: 'N2O', total: '-' },
                  { gasName: 'HFCs', total: '-' },
                  { gasName: 'PFCs', total: '-' },
                  { gasName: 'SF6', total: '-' },
                  { gasName: 'NF3', total: '-' }
                ]}
                showSerialNumber={true}
              />
            </div>
          </div>
        )}

        {/* 305-3: Other indirect (Scope 3) GHG emissions */}
        <h1 className={styles.mainHeading}>
          305-3 : OTHER INDIRECT (SCOPE 3) GHG EMISSIONS
        </h1>
        
        {scope3EmissionsData ? (
          <div className={styles.consolidatingSection}>
            {/* Sub-section a: Total Scope 3 emissions */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. What is the total amount of greenhouse gas emissions in metric tons of CO2 equivalent emitted directly (Scope 3 emissions) by the organization?
              </p>
              <p className={styles.questionAnswer}>
                {scope3EmissionsData?.scope3EmissionsTotal || '-'}
              </p>
            </div>

            {/* Sub-section b: Gases included */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                b. Gases included in the calculation:
              </p>
              {(() => {
                const gasesColumns = [
                  { field: 'gasName', label: 'Gas Name', width: '50%' },
                  { field: 'total', label: 'Total Emission', width: '50%' }
                ]
                
                const gasesRows = scope3EmissionsData?.gasesIncluded && Array.isArray(scope3EmissionsData.gasesIncluded) && scope3EmissionsData.gasesIncluded.length > 0
                  ? scope3EmissionsData.gasesIncluded.map((item) => ({
                      gasName: item?.gasName || '-',
                      total: item?.total || '-'
                    }))
                  : [
                      { gasName: 'CO2', total: '-' },
                      { gasName: 'CH4', total: '-' },
                      { gasName: 'N2O', total: '-' },
                      { gasName: 'HFCs', total: '-' },
                      { gasName: 'PFCs', total: '-' },
                      { gasName: 'SF6', total: '-' },
                      { gasName: 'NF3', total: '-' }
                    ]
                
                return (
                  <ReportTable
                    columns={gasesColumns}
                    rows={gasesRows}
                    showSerialNumber={true}
                  />
                )
              })()}
            </div>

            {/* Sub-section c: Biogenic CO2 emissions */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                c. What is the biogenic CO2 emissions in metric tons of CO2 equivalent?
              </p>
              <p className={styles.questionAnswer}>
                {scope3EmissionsData?.biogenicCO2Emissions || '-'}
              </p>
            </div>

            {/* Sub-section d: Other indirect categories */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                d. Other indirect (Scope 3) GHG emissions categories and activities included in the calculation.
              </p>
              <p className={styles.questionAnswer}>
                {scope3EmissionsData?.otherIndirectGHGEmissionsCategories || '-'}
              </p>
            </div>

            {/* Sub-section e: Base year */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                e. If applicable, define base year for the calculation:
              </p>
              
              <div className={styles.questionBox}>
                <p className={styles.subQuestionTitle}>
                  i. The rationale behind the selection of the base year.
                </p>
                <p className={styles.questionAnswer}>
                  {scope3EmissionsData?.baseYearEmissionData?.rationaleBehind || '-'}
                </p>
              </div>

              <div className={styles.questionBox}>
                <p className={styles.subQuestionTitle}>
                  ii. The total emissions recorded in the base year.
                </p>
                <p className={styles.questionAnswer}>
                  {scope3EmissionsData?.baseYearEmissionData?.totalEmission || '-'}
                </p>
              </div>

              <div className={styles.questionBox}>
                <p className={styles.subQuestionTitle}>
                  iii. Provide context for any significant changes in emissions that prompted the recalculation of base year emissions.
                </p>
                <p className={styles.questionAnswer}>
                  {scope3EmissionsData?.baseYearEmissionData?.recalculationBaseYear || '-'}
                </p>
              </div>
            </div>

            {/* Sub-section f: Emission factors */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                f. What is the source of the emission factors and global warming potential (GWP) rates used in emissions calculations? Provide references to the source if available.
              </p>
              <p className={styles.questionAnswer}>
                {scope3EmissionsData?.emissionFactorsGWPReferences || '-'}
              </p>
            </div>

            {/* Sub-section g: Calculation methods */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                g. What standards, methodologies, assumptions, and/or calculation tools were utilized in emissions calculations?
              </p>
              <p className={styles.questionAnswer}>
                {scope3EmissionsData?.emissionsCalculationMethods || '-'}
              </p>
            </div>
          </div>
        ) : (
          <div className={styles.consolidatingSection}>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. What is the total amount of greenhouse gas emissions in metric tons of CO2 equivalent emitted directly (Scope 3 emissions) by the organization?
              </p>
              <p className={styles.questionAnswer}>
                -
              </p>
            </div>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                b. Gases included in the calculation:
              </p>
              <ReportTable
                columns={[
                  { field: 'gasName', label: 'Gas Name', width: '50%' },
                  { field: 'total', label: 'Total Emission', width: '50%' }
                ]}
                rows={[
                  { gasName: 'CO2', total: '-' },
                  { gasName: 'CH4', total: '-' },
                  { gasName: 'N2O', total: '-' },
                  { gasName: 'HFCs', total: '-' },
                  { gasName: 'PFCs', total: '-' },
                  { gasName: 'SF6', total: '-' },
                  { gasName: 'NF3', total: '-' }
                ]}
                showSerialNumber={true}
              />
            </div>
          </div>
        )}

        {/* 305-4: GHG emissions intensity */}
        <h1 className={styles.mainHeading}>
          305-4 : GHG EMISSIONS INTENSITY
        </h1>
        
        {emissionsIntensityData ? (
          <div className={styles.consolidatingSection}>
            {/* Sub-section a: Intensity ratio */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. GHG emissions intensity ratio for the organization
              </p>
              <p className={styles.questionAnswer}>
                {emissionsIntensityData?.emissionsIntensityRatio || '-'}
              </p>
            </div>

            {/* Sub-section b: Denominator */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                b. Organization-Specific metric (Denominator) chosen to calculate the ratio:
              </p>
              <p className={styles.questionAnswer}>
                {emissionsIntensityData?.emissionsIntensityDenominator || '-'}
              </p>
            </div>

            {/* Sub-section c: Types of GHG emissions included */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                c. Types of GHG emissions included in the intensity ratio:
              </p>
              <p className={styles.questionAnswer}>
                {emissionsIntensityData?.includedGHGEmissions && emissionsIntensityData.includedGHGEmissions.length > 0 ? emissionsIntensityData.includedGHGEmissions.join(', ') : '-'}
              </p>
            </div>

            {/* Sub-section d: Gases included */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                d. Gases included in the calculation:
              </p>
              {(() => {
                const gasesColumns = [
                  { field: 'gasName', label: 'Gas Name', width: '50%' },
                  { field: 'total', label: 'Total Emission', width: '50%' }
                ]
                
                const gasesRows = emissionsIntensityData?.gasesIncluded && Array.isArray(emissionsIntensityData.gasesIncluded) && emissionsIntensityData.gasesIncluded.length > 0
                  ? emissionsIntensityData.gasesIncluded.map((item) => ({
                      gasName: item?.gasName || '-',
                      total: item?.total || '-'
                    }))
                  : [
                      { gasName: 'CO2', total: '-' },
                      { gasName: 'CH4', total: '-' },
                      { gasName: 'N2O', total: '-' },
                      { gasName: 'HFCs', total: '-' },
                      { gasName: 'PFCs', total: '-' },
                      { gasName: 'SF6', total: '-' },
                      { gasName: 'NF3', total: '-' }
                    ]
                
                return (
                  <ReportTable
                    columns={gasesColumns}
                    rows={gasesRows}
                    showSerialNumber={true}
                  />
                )
              })()}
            </div>
          </div>
        ) : (
          <div className={styles.consolidatingSection}>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. GHG emissions intensity ratio for the organization
              </p>
              <p className={styles.questionAnswer}>
                -
              </p>
            </div>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                d. Gases included in the calculation:
              </p>
              <ReportTable
                columns={[
                  { field: 'gasName', label: 'Gas Name', width: '50%' },
                  { field: 'total', label: 'Total Emission', width: '50%' }
                ]}
                rows={[
                  { gasName: 'CO2', total: '-' },
                  { gasName: 'CH4', total: '-' },
                  { gasName: 'N2O', total: '-' },
                  { gasName: 'HFCs', total: '-' },
                  { gasName: 'PFCs', total: '-' },
                  { gasName: 'SF6', total: '-' },
                  { gasName: 'NF3', total: '-' }
                ]}
                showSerialNumber={true}
              />
            </div>
          </div>
        )}

        {/* 305-5: Reduction of GHG emissions */}
        <h1 className={styles.mainHeading}>
          305-5 : REDUCTION OF GHG EMISSIONS
        </h1>
        
        {emissionsReductionData ? (
          <div className={styles.consolidatingSection}>
            {/* Sub-section a: Reduction initiatives */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. GHG emissions reduced as a direct result of reduction initiatives, in metric tons of CO2 equivalent.
              </p>
              {(() => {
                const reductionColumns = [
                  { field: 'reductions', label: 'Reduction initiatives', width: '35%' },
                  { field: 'value', label: 'Value', width: '22%' },
                  { field: 'unit', label: 'Unit', width: '22%' }
                ]
                
                const reductionRows = emissionsReductionData?.reductionIntiative && Array.isArray(emissionsReductionData.reductionIntiative) && emissionsReductionData.reductionIntiative.length > 0
                  ? emissionsReductionData.reductionIntiative.map((item) => ({
                      reductions: item?.reductions || '-',
                      value: item?.value || '-',
                      unit: item?.unit || '-'
                    }))
                  : [
                      { reductions: 'Process redesign', value: '-', unit: '-' },
                      { reductions: 'Conversion and retrofitting of equipment', value: '-', unit: '-' },
                      { reductions: 'Change in behavior', value: '-', unit: '-' },
                      { reductions: 'Offsets', value: '-', unit: '-' },
                      { reductions: 'Fuel changes', value: '-', unit: '-' }
                    ]
                
                return (
                  <ReportTable
                    columns={reductionColumns}
                    rows={reductionRows}
                    showSerialNumber={true}
                  />
                )
              })()}
            </div>

            {/* Sub-section b: Gases included */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                b. Gases included in the calculation:
              </p>
              {(() => {
                const gasesColumns = [
                  { field: 'gasName', label: 'Gas Name', width: '50%' },
                  { field: 'total', label: 'Total Emission', width: '50%' }
                ]
                
                const gasesRows = emissionsReductionData?.gasesIncluded && Array.isArray(emissionsReductionData.gasesIncluded) && emissionsReductionData.gasesIncluded.length > 0
                  ? emissionsReductionData.gasesIncluded.map((item) => ({
                      gasName: item?.gasName || '-',
                      total: item?.total || '-'
                    }))
                  : [
                      { gasName: 'CO2', total: '-' },
                      { gasName: 'CH4', total: '-' },
                      { gasName: 'N2O', total: '-' },
                      { gasName: 'HFCs', total: '-' },
                      { gasName: 'PFCs', total: '-' },
                      { gasName: 'SF6', total: '-' },
                      { gasName: 'NF3', total: '-' }
                    ]
                
                return (
                  <ReportTable
                    columns={gasesColumns}
                    rows={gasesRows}
                    showSerialNumber={true}
                  />
                )
              })()}
            </div>

            {/* Sub-section c: Base year */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                c. Mention the base year for calculation and the statement mentioning why?
              </p>
              <p className={styles.questionAnswer}>
                {emissionsReductionData?.baseYear || '-'}
              </p>
            </div>

            {/* Sub-section d: Reduction scope */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                d. Scope in which reductions took place.
              </p>
              <p className={styles.questionAnswer}>
                {emissionsReductionData?.reductionScope && emissionsReductionData.reductionScope.length > 0 ? emissionsReductionData.reductionScope.join(', ') : '-'}
              </p>
            </div>

            {/* Sub-section e: Calculation used */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                e. What are the standards, methodologies, assumptions, and/or calculations used?
              </p>
              <p className={styles.questionAnswer}>
                {emissionsReductionData?.calculationUsed || '-'}
              </p>
            </div>
          </div>
        ) : (
          <div className={styles.consolidatingSection}>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. GHG emissions reduced as a direct result of reduction initiatives, in metric tons of CO2 equivalent.
              </p>
              <ReportTable
                columns={[
                  { field: 'reductions', label: 'Reduction initiatives', width: '35%' },
                  { field: 'value', label: 'Value', width: '22%' },
                  { field: 'unit', label: 'Unit', width: '22%' }
                ]}
                rows={[
                  { reductions: 'Process redesign', value: '-', unit: '-' },
                  { reductions: 'Conversion and retrofitting of equipment', value: '-', unit: '-' },
                  { reductions: 'Change in behavior', value: '-', unit: '-' },
                  { reductions: 'Offsets', value: '-', unit: '-' },
                  { reductions: 'Fuel changes', value: '-', unit: '-' }
                ]}
                showSerialNumber={true}
              />
            </div>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                b. Gases included in the calculation:
              </p>
              <ReportTable
                columns={[
                  { field: 'gasName', label: 'Gas Name', width: '50%' },
                  { field: 'total', label: 'Total Emission', width: '50%' }
                ]}
                rows={[
                  { gasName: 'CO2', total: '-' },
                  { gasName: 'CH4', total: '-' },
                  { gasName: 'N2O', total: '-' },
                  { gasName: 'HFCs', total: '-' },
                  { gasName: 'PFCs', total: '-' },
                  { gasName: 'SF6', total: '-' },
                  { gasName: 'NF3', total: '-' }
                ]}
                showSerialNumber={true}
              />
            </div>
          </div>
        )}

        {/* 305-6: Emissions of ozone-depleting substances */}
        <h1 className={styles.mainHeading}>
          305-6 : EMISSIONS OF OZONE-DEPLETING SUBSTANCES (ODS)
        </h1>
        
        {ozoneDepletingData ? (
          <div className={styles.consolidatingSection}>
            {/* Sub-section a: Total ODS production */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. Total Ozone Depleting Substances from activity in metric tons of CFC-11 eq.
              </p>
              {(() => {
                const odsColumns = [
                  { field: 'processOfCompany', label: 'Process of Company', width: '19%' },
                  { field: 'odsProduction', label: 'ODS produced', width: '16%' },
                  { field: 'odsDestroyed', label: 'ODS destroyed by approved Technologies', width: '20%' },
                  { field: 'odsEntirelyUsed', label: 'ODS entirely used as feedstock in the manufacture of other chemicals', width: '20%' },
                  { field: 'productionOds', label: 'Production of ODS', width: '16%' }
                ]
                
                const odsRows = ozoneDepletingData?.odsProduction && Array.isArray(ozoneDepletingData.odsProduction) && ozoneDepletingData.odsProduction.length > 0
                  ? ozoneDepletingData.odsProduction.map((item) => ({
                      processOfCompany: item?.processOfCompany || '-',
                      odsProduction: item?.odsProduction || '-',
                      odsDestroyed: item?.odsDestroyed || '-',
                      odsEntirelyUsed: item?.odsEntirelyUsed || '-',
                      productionOds: item?.productionOds || '-'
                    }))
                  : [
                      { processOfCompany: 'Production', odsProduction: '-', odsDestroyed: '-', odsEntirelyUsed: '-', productionOds: '-' },
                      { processOfCompany: 'Imports', odsProduction: '-', odsDestroyed: '-', odsEntirelyUsed: '-', productionOds: '-' },
                      { processOfCompany: 'Exports', odsProduction: '-', odsDestroyed: '-', odsEntirelyUsed: '-', productionOds: '-' }
                    ]
                
                return (
                  <ReportTable
                    columns={odsColumns}
                    rows={odsRows}
                    showSerialNumber={true}
                  />
                )
              })()}
            </div>

            {/* Sub-section b: Substances included */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                b. What are the substances included in the calculations?
              </p>
              <p className={styles.questionAnswer}>
                {ozoneDepletingData?.substancesIncluded && ozoneDepletingData.substancesIncluded.length > 0 ? ozoneDepletingData.substancesIncluded.join(', ') : '-'}
              </p>
            </div>

            {/* Sub-section c: Emission factors */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                c. Specify the emission factors to be taken for calculation
              </p>
              <p className={styles.questionAnswer}>
                {ozoneDepletingData?.specifyEmission || '-'}
              </p>
            </div>

            {/* Sub-section d: Standards and methodologies */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                d. Which are the standards, methodologies, assumptions, and/or calculation tools used.
              </p>
              <p className={styles.questionAnswer}>
                {ozoneDepletingData?.standardsMethodologies || '-'}
              </p>
            </div>
          </div>
        ) : (
          <div className={styles.consolidatingSection}>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. Total Ozone Depleting Substances from activity in metric tons of CFC-11 eq.
              </p>
              <ReportTable
                columns={[
                  { field: 'processOfCompany', label: 'Process of Company', width: '19%' },
                  { field: 'odsProduction', label: 'ODS produced', width: '16%' },
                  { field: 'odsDestroyed', label: 'ODS destroyed by approved Technologies', width: '20%' },
                  { field: 'odsEntirelyUsed', label: 'ODS entirely used as feedstock in the manufacture of other chemicals', width: '20%' },
                  { field: 'productionOds', label: 'Production of ODS', width: '16%' }
                ]}
                rows={[
                  { processOfCompany: 'Production', odsProduction: '-', odsDestroyed: '-', odsEntirelyUsed: '-', productionOds: '-' },
                  { processOfCompany: 'Imports', odsProduction: '-', odsDestroyed: '-', odsEntirelyUsed: '-', productionOds: '-' },
                  { processOfCompany: 'Exports', odsProduction: '-', odsDestroyed: '-', odsEntirelyUsed: '-', productionOds: '-' }
                ]}
                showSerialNumber={true}
              />
            </div>
          </div>
        )}

        {/* 305-7: Nitrogen oxides, sulphur oxides, and other significant air emissions */}
        <h1 className={styles.mainHeading}>
          305-7 : NITROGEN OXIDES (NOX), SULPHUR OXIDES (SOX), AND OTHER SIGNIFICANT AIR EMISSIONS
        </h1>
        
        {airEmissionsNOxSOxData ? (
          <div className={styles.consolidatingSection}>
            {/* Sub-section a: Significant air emissions */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. What are the significant air emissions from processes:
              </p>
              {(() => {
                const airColumns = [
                  { field: 'gasName', label: 'Gas Name', width: '50%' },
                  { field: 'total', label: 'Total Emission', width: '50%' }
                ]
                
                const airRows = airEmissionsNOxSOxData?.airEmission && Array.isArray(airEmissionsNOxSOxData.airEmission) && airEmissionsNOxSOxData.airEmission.length > 0
                  ? airEmissionsNOxSOxData.airEmission.map((item) => ({
                      gasName: item?.gasName || '-',
                      total: item?.total || '-'
                    }))
                  : [
                      { gasName: 'NOx', total: '-' },
                      { gasName: 'SOx', total: '-' },
                      { gasName: 'Persistent organic pollutants (POP)', total: '-' },
                      { gasName: 'Volatile organic compounds (VOC)', total: '-' },
                      { gasName: 'Hazardous air Pollutants (HAP)', total: '-' },
                      { gasName: 'Particulate Matter (PM)', total: '-' }
                    ]
                
                return (
                  <ReportTable
                    columns={airColumns}
                    rows={airRows}
                    showSerialNumber={true}
                  />
                )
              })()}
            </div>

            {/* Sub-section b: Emission factors */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                b. Which emission factors were used for calculation?
              </p>
              <p className={styles.questionAnswer}>
                {airEmissionsNOxSOxData?.emissionFactorCalculation || '-'}
              </p>
            </div>

            {/* Sub-section c: Calculation tools */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                c. What standards, methodologies, assumptions, and/or calculation tools were used?
              </p>
              <p className={styles.questionAnswer}>
                {airEmissionsNOxSOxData?.calculationTools || '-'}
              </p>
            </div>
          </div>
        ) : (
          <div className={styles.consolidatingSection}>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. What are the significant air emissions from processes:
              </p>
              <ReportTable
                columns={[
                  { field: 'gasName', label: 'Gas Name', width: '50%' },
                  { field: 'total', label: 'Total Emission', width: '50%' }
                ]}
                rows={[
                  { gasName: 'NOx', total: '-' },
                  { gasName: 'SOx', total: '-' },
                  { gasName: 'Persistent organic pollutants (POP)', total: '-' },
                  { gasName: 'Volatile organic compounds (VOC)', total: '-' },
                  { gasName: 'Hazardous air Pollutants (HAP)', total: '-' },
                  { gasName: 'Particulate Matter (PM)', total: '-' }
                ]}
                showSerialNumber={true}
              />
            </div>
          </div>
        )}
      </div>

      {/* GRI 306 - Waste */}
      <div className={styles.container}>
        <p className={styles.sectionHeading}>
          306: WASTE
        </p>
        
        {/* 306-1: Waste generation and significant waste-related impacts */}
        <h1 className={styles.mainHeading}>
          306-1 : WASTE GENERATION AND SIGNIFICANT WASTE-RELATED IMPACTS
        </h1>
        
        {wasteRelatedImpactData ? (
          <div className={styles.consolidatingSection}>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. Describe the organization's significant actual and potential waste-related impacts:
              </p>
              <p className={styles.questionAnswer}>
                {wasteRelatedImpactData?.wasteRelatedImpacts || '-'}
              </p>
              
              <div className={styles.questionBox}>
                <p className={styles.subQuestionTitle}>
                  i. The inputs, activities, and outputs that lead or could lead to these impacts.
                </p>
                <p className={styles.questionAnswer}>
                  {wasteRelatedImpactData?.impactInputsActivitiesOutputs || '-'}
                </p>
              </div>

              <div className={styles.questionBox}>
                <p className={styles.subQuestionTitle}>
                  ii. Do these impacts relate to waste generated in the organization's own activities or to waste generated upstream or downstream in its value chain?
                </p>
                <p className={styles.questionAnswer}>
                  {wasteRelatedImpactData?.wasteImpactScope || '-'}
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.consolidatingSection}>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. Describe the organization's significant actual and potential waste-related impacts:
              </p>
              <p className={styles.questionAnswer}>
                -
              </p>
            </div>
          </div>
        )}

        {/* 306-2: Management of significant waste related impacts */}
        <h1 className={styles.mainHeading}>
          306-2 : MANAGEMENT OF SIGNIFICANT WASTE RELATED IMPACTS
        </h1>
        
        {wasteImpactManagementData ? (
          <div className={styles.consolidatingSection}>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. Describe the actions, including circularity measures, implemented to prevent waste generation within the organization's own activities and throughout its value chain, and to address significant impacts resulting from waste generated.
              </p>
              <p className={styles.questionAnswer}>
                {wasteImpactManagementData?.wastePreventionActions || '-'}
              </p>
            </div>

            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                b. If the waste generated by the organization in its own activities is managed by a third party, provide a description of the processes used to assess whether the third party manages the waste in accordance with contractual or legislative obligations.
              </p>
              <p className={styles.questionAnswer}>
                {wasteImpactManagementData?.wasteManagementAssessment || '-'}
              </p>
            </div>

            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                c. Outline the processes utilized for the collection and monitoring of waste-related data.
              </p>
              <p className={styles.questionAnswer}>
                {wasteImpactManagementData?.wasteDataCollectionMonitoring || '-'}
              </p>
            </div>
          </div>
        ) : (
          <div className={styles.consolidatingSection}>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. Describe the actions, including circularity measures, implemented to prevent waste generation within the organization's own activities and throughout its value chain, and to address significant impacts resulting from waste generated.
              </p>
              <p className={styles.questionAnswer}>
                -
              </p>
            </div>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                b. If the waste generated by the organization in its own activities is managed by a third party, provide a description of the processes used to assess whether the third party manages the waste in accordance with contractual or legislative obligations.
              </p>
              <p className={styles.questionAnswer}>
                -
              </p>
            </div>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                c. Outline the processes utilized for the collection and monitoring of waste-related data.
              </p>
              <p className={styles.questionAnswer}>
                -
              </p>
            </div>
          </div>
        )}

        {/* 306-3: Waste generated */}
        <h1 className={styles.mainHeading}>
          306-3 : WASTE GENERATED
        </h1>
        
        {wasteGeneratedData ? (
          <div className={styles.consolidatingSection}>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. Provide the total weight of waste generated in metric tons, along with a breakdown of this total by the composition of the waste?
              </p>
              
              {wasteGeneratedData?.total && (
                <div className={styles.questionRow}>
                  <span className={styles.questionLabel}>Total:</span>
                  <span className={styles.questionValue}>
                    {wasteGeneratedData?.total?.value || '-'} {wasteGeneratedData?.total?.unit || ''}
                  </span>
                </div>
              )}
              
              {(() => {
                const wasteColumns = [
                  { field: 'typeOfWaste', label: 'Type of Waste', width: '50%' },
                  { field: 'quantity', label: 'Quantity', width: '50%' }
                ]
                
                const wasteRows = wasteGeneratedData?.totalWasteGenerated && Array.isArray(wasteGeneratedData.totalWasteGenerated) && wasteGeneratedData.totalWasteGenerated.length > 0
                  ? wasteGeneratedData.totalWasteGenerated.map((item) => ({
                      typeOfWaste: item?.typeOfWaste || '-',
                      quantity: item?.quantity || '-'
                    }))
                  : [
                      { typeOfWaste: 'Hazardous Waste', quantity: '-' },
                      { typeOfWaste: 'Non-Hazardous Waste', quantity: '-' },
                      { typeOfWaste: 'Electronic Waste', quantity: '-' },
                      { typeOfWaste: 'Food Waste', quantity: '-' },
                      { typeOfWaste: 'Biowaste', quantity: '-' }
                    ]
                
                return (
                  <ReportTable
                    columns={wasteColumns}
                    rows={wasteRows}
                    showSerialNumber={true}
                    showTotal={true}
                    totalValue={wasteGeneratedData?.total?.value || '-'}
                  />
                )
              })()}
            </div>

            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                b. Provide contextual information that is essential for understanding the data and detail how the data has been compiled.
              </p>
              <p className={styles.questionAnswer}>
                {wasteGeneratedData?.wasteDataContext || '-'}
              </p>
            </div>
          </div>
        ) : (
          <div className={styles.consolidatingSection}>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. Provide the total weight of waste generated in metric tons, along with a breakdown of this total by the composition of the waste?
              </p>
              <ReportTable
                columns={[
                  { field: 'typeOfWaste', label: 'Type of Waste', width: '50%' },
                  { field: 'quantity', label: 'Quantity', width: '50%' }
                ]}
                rows={[
                  { typeOfWaste: 'Hazardous Waste', quantity: '-' },
                  { typeOfWaste: 'Non-Hazardous Waste', quantity: '-' },
                  { typeOfWaste: 'Electronic Waste', quantity: '-' },
                  { typeOfWaste: 'Food Waste', quantity: '-' },
                  { typeOfWaste: 'Biowaste', quantity: '-' }
                ]}
                showSerialNumber={true}
                showTotal={true}
                totalValue={wasteGeneratedData?.total?.value || '-'}
              />
            </div>
          </div>
        )}

        {/* 306-4: Waste diverted from disposal */}
        <h1 className={styles.mainHeading}>
          306-4 : WASTE DIVERTED FROM DISPOSAL
        </h1>
        
        {wasteDivertedData ? (
          <div className={styles.consolidatingSection}>
            {/* Sub-section a: Total waste diverted */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. Provide the total weight of waste diverted from disposal in metric tonnes, and provide a breakdown of this total by the composition of the waste?
              </p>
              
              {wasteDivertedData?.wasteDiversionBreakdownTotal && (
                <div className={styles.questionRow}>
                  <span className={styles.questionLabel}>Total:</span>
                  <span className={styles.questionValue}>
                    {wasteDivertedData?.wasteDiversionBreakdownTotal?.value || '-'} {wasteDivertedData?.wasteDiversionBreakdownTotal?.unit || ''}
                  </span>
                </div>
              )}
              
              {(() => {
                const diversionColumns = [
                  { field: 'typeOfWaste', label: 'Metrics', width: '30%' },
                  { field: 'quantity', label: 'Value', width: '30%' }
                ]
                
                const diversionRows = wasteDivertedData?.wasteDiversionBreakdown && Array.isArray(wasteDivertedData.wasteDiversionBreakdown) && wasteDivertedData.wasteDiversionBreakdown.length > 0
                  ? wasteDivertedData.wasteDiversionBreakdown.map((item) => ({
                      typeOfWaste: item?.typeOfWaste || '-',
                      quantity: item?.quantity || '-'
                    }))
                  : [
                      { typeOfWaste: 'Hazardous Waste', quantity: '-' },
                      { typeOfWaste: 'Non-Hazardous Waste', quantity: '-' },
                      { typeOfWaste: 'Metallic', quantity: '-' },
                      { typeOfWaste: 'Non-metallic', quantity: '-' },
                      { typeOfWaste: 'Plastics', quantity: '-' },
                      { typeOfWaste: 'Electronic', quantity: '-' },
                      { typeOfWaste: 'Biomass', quantity: '-' },
                      { typeOfWaste: 'Others', quantity: '-' }
                    ]
                
                return (
                  <ReportTable
                    columns={diversionColumns}
                    rows={diversionRows}
                    showSerialNumber={true}
                    showTotal={true}
                    totalValue={wasteDivertedData?.wasteDiversionBreakdownTotal?.value || '-'}
                  />
                )
              })()}
            </div>

            {/* Sub-section b: Hazardous waste diverted */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                b. What is the total weight of hazardous waste diverted from disposal to recovery?
              </p>
              
              {wasteDivertedData?.hazardousWasteRecoveryTotals && (
                <div className={styles.questionRow}>
                  <span className={styles.questionLabel}>Total:</span>
                  <span className={styles.questionValue}>
                    {wasteDivertedData?.hazardousWasteRecoveryTotals?.value || '-'} {wasteDivertedData?.hazardousWasteRecoveryTotals?.unit || ''}
                  </span>
                </div>
              )}
              
              {(() => {
                const hazardousColumns = [
                  { field: 'typeOfWaste', label: 'Recovery Option', width: '50%' },
                  { field: 'quantity', label: 'Quantity', width: '50%' }
                ]
                
                const hazardousRows = wasteDivertedData?.hazardousWasteRecoveryTotal && Array.isArray(wasteDivertedData.hazardousWasteRecoveryTotal) && wasteDivertedData.hazardousWasteRecoveryTotal.length > 0
                  ? wasteDivertedData.hazardousWasteRecoveryTotal.map((item) => ({
                      typeOfWaste: item?.typeOfWaste || '-',
                      quantity: item?.quantity || '-'
                    }))
                  : [
                      { typeOfWaste: 'Preparation for Reuse', quantity: '-' },
                      { typeOfWaste: 'Recycling', quantity: '-' },
                      { typeOfWaste: 'Other Recovery Operations', quantity: '-' }
                    ]
                
                return (
                  <ReportTable
                    columns={hazardousColumns}
                    rows={hazardousRows}
                    showSerialNumber={true}
                    showTotal={true}
                    totalValue={wasteDivertedData?.hazardousWasteRecoveryTotals?.value || '-'}
                  />
                )
              })()}
            </div>

            {/* Sub-section c: Non-hazardous waste diverted */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                c. What is the total weight of non-hazardous waste diverted from disposal to recovery?
              </p>
              
              {wasteDivertedData?.nonHazardousWasteRecoveryTotals && (
                <div className={styles.questionRow}>
                  <span className={styles.questionLabel}>Total:</span>
                  <span className={styles.questionValue}>
                    {wasteDivertedData?.nonHazardousWasteRecoveryTotals?.value || '-'} {wasteDivertedData?.nonHazardousWasteRecoveryTotals?.unit || ''}
                  </span>
                </div>
              )}
              
              {(() => {
                const nonHazardousColumns = [
                  { field: 'typeOfWaste', label: 'Recovery Option', width: '50%' },
                  { field: 'quantity', label: 'Quantity', width: '50%' }
                ]
                
                const nonHazardousRows = wasteDivertedData?.nonHazardousWasteRecoveryTotal && Array.isArray(wasteDivertedData.nonHazardousWasteRecoveryTotal) && wasteDivertedData.nonHazardousWasteRecoveryTotal.length > 0
                  ? wasteDivertedData.nonHazardousWasteRecoveryTotal.map((item) => ({
                      typeOfWaste: item?.typeOfWaste || '-',
                      quantity: item?.quantity || '-'
                    }))
                  : [
                      { typeOfWaste: 'Preparation for Reuse', quantity: '-' },
                      { typeOfWaste: 'Recycling', quantity: '-' },
                      { typeOfWaste: 'Other Recovery Operations', quantity: '-' }
                    ]
                
                return (
                  <ReportTable
                    columns={nonHazardousColumns}
                    rows={nonHazardousRows}
                    showSerialNumber={true}
                    showTotal={true}
                    totalValue={wasteDivertedData?.nonHazardousWasteRecoveryTotals?.value || '-'}
                  />
                )
              })()}
            </div>

            {/* Sub-section d: Onsite/Offsite definition */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                d. For every directed disposal outlined in Disclosures 306-4-b and 306-4-c, detail the total weight in metric tons of hazardous waste and non-hazardous waste diverted from disposal.
              </p>
              
              {wasteDivertedData?.onsiteOffsiteDefinitionTotals && (
                <div className={styles.questionRow}>
                  <span className={styles.questionLabel}>Total:</span>
                  <span className={styles.questionValue}>
                    {wasteDivertedData?.onsiteOffsiteDefinitionTotals?.value || '-'} {wasteDivertedData?.onsiteOffsiteDefinitionTotals?.unit || ''}
                  </span>
                </div>
              )}
              
              {(() => {
                const onsiteColumns = [
                  { field: 'typeOfWaste', label: 'Recovery From Site', width: '50%' },
                  { field: 'quantity', label: 'Quantity', width: '50%' }
                ]
                
                const onsiteRows = wasteDivertedData?.onsiteOffsiteDefinition && Array.isArray(wasteDivertedData.onsiteOffsiteDefinition) && wasteDivertedData.onsiteOffsiteDefinition.length > 0
                  ? wasteDivertedData.onsiteOffsiteDefinition.map((item) => ({
                      typeOfWaste: item?.typeOfWaste || '-',
                      quantity: item?.quantity || '-'
                    }))
                  : [
                      { typeOfWaste: 'Onsite Recovery', quantity: '-' },
                      { typeOfWaste: 'Offline Recovery', quantity: '-' }
                    ]
                
                return (
                  <ReportTable
                    columns={onsiteColumns}
                    rows={onsiteRows}
                    showSerialNumber={true}
                    showTotal={true}
                    totalValue={wasteDivertedData?.onsiteOffsiteDefinitionTotals?.value || '-'}
                  />
                )
              })()}
            </div>

            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                e. Provide contextual information necessary to understand the data and how the data has been compiled.
              </p>
              <p className={styles.questionAnswer}>
                {wasteDivertedData?.dataCompilationContext || '-'}
              </p>
            </div>
          </div>
        ) : (
          <div className={styles.consolidatingSection}>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. Provide the total weight of waste diverted from disposal in metric tonnes, and provide a breakdown of this total by the composition of the waste?
              </p>
              <ReportTable
                columns={[
                  { field: 'typeOfWaste', label: 'Metrics', width: '30%' },
                  { field: 'quantity', label: 'Value', width: '30%' }
                ]}
                rows={[
                  { typeOfWaste: 'Hazardous Waste', quantity: '-' },
                  { typeOfWaste: 'Non-Hazardous Waste', quantity: '-' },
                  { typeOfWaste: 'Metallic', quantity: '-' },
                  { typeOfWaste: 'Non-metallic', quantity: '-' },
                  { typeOfWaste: 'Plastics', quantity: '-' },
                  { typeOfWaste: 'Electronic', quantity: '-' },
                  { typeOfWaste: 'Biomass', quantity: '-' },
                  { typeOfWaste: 'Others', quantity: '-' }
                ]}
                showSerialNumber={true}
              />
            </div>
          </div>
        )}

        {/* 306-5: Waste directed to disposal */}
        <h1 className={styles.mainHeading}>
          306-5 : WASTE DIRECTED TO DISPOSAL
        </h1>
        
        {wasteToDisposalData ? (
          <div className={styles.consolidatingSection}>
            {/* Sub-section a: Total waste directed to disposal */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. Provide the total weight of waste directed to disposal by composition of the waste?
              </p>
              
              {wasteToDisposalData?.wasteDisposalByCompositionTotal && (
                <div className={styles.questionRow}>
                  <span className={styles.questionLabel}>Total:</span>
                  <span className={styles.questionValue}>
                    {wasteToDisposalData?.wasteDisposalByCompositionTotal?.value || '-'} {wasteToDisposalData?.wasteDisposalByCompositionTotal?.unit || ''}
                  </span>
                </div>
              )}
              
              {(() => {
                const disposalColumns = [
                  { field: 'typeOfWaste', label: 'Type of Waste', width: '50%' },
                  { field: 'quantity', label: 'Value', width: '50%' }
                ]
                
                const disposalRows = wasteToDisposalData?.wasteDisposalByComposition && Array.isArray(wasteToDisposalData.wasteDisposalByComposition) && wasteToDisposalData.wasteDisposalByComposition.length > 0
                  ? wasteToDisposalData.wasteDisposalByComposition.map((item) => ({
                      typeOfWaste: item?.typeOfWaste || '-',
                      quantity: item?.quantity || '-'
                    }))
                  : [
                      { typeOfWaste: 'Hazardous Waste', quantity: '-' },
                      { typeOfWaste: 'Non-Hazardous Waste', quantity: '-' },
                      { typeOfWaste: 'Electronic Waste', quantity: '-' },
                      { typeOfWaste: 'Food Waste', quantity: '-' },
                      { typeOfWaste: 'Biowaste', quantity: '-' }
                    ]
                
                return (
                  <ReportTable
                    columns={disposalColumns}
                    rows={disposalRows}
                    showSerialNumber={true}
                    showTotal={true}
                    totalValue={wasteToDisposalData?.wasteDisposalByCompositionTotal?.value || '-'}
                  />
                )
              })()}
            </div>

            {/* Sub-section b: Hazardous waste directed to disposal */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                b. What is the total weight of hazardous waste directed to disposal in metric tons?
              </p>
              
              {wasteToDisposalData?.hazardousWasteDisposalBreakdownTotal && (
                <div className={styles.questionRow}>
                  <span className={styles.questionLabel}>Total:</span>
                  <span className={styles.questionValue}>
                    {wasteToDisposalData?.hazardousWasteDisposalBreakdownTotal?.value || '-'} {wasteToDisposalData?.hazardousWasteDisposalBreakdownTotal?.unit || ''}
                  </span>
                </div>
              )}
              
              {(() => {
                const hazardousDisposalColumns = [
                  { field: 'typeOfWaste', label: 'Type of Waste', width: '50%' },
                  { field: 'quantity', label: 'Quantity', width: '50%' }
                ]
                
                const hazardousDisposalRows = wasteToDisposalData?.hazardousWasteDisposalBreakdown && Array.isArray(wasteToDisposalData.hazardousWasteDisposalBreakdown) && wasteToDisposalData.hazardousWasteDisposalBreakdown.length > 0
                  ? wasteToDisposalData.hazardousWasteDisposalBreakdown.map((item) => ({
                      typeOfWaste: item?.typeOfWaste || '-',
                      quantity: item?.quantity || '-'
                    }))
                  : [
                      { typeOfWaste: 'Incineration (With energy recovery)', quantity: '-' },
                      { typeOfWaste: 'Incineration (Without energy recovery)', quantity: '-' },
                      { typeOfWaste: 'Landfilling', quantity: '-' }
                    ]
                
                return (
                  <ReportTable
                    columns={hazardousDisposalColumns}
                    rows={hazardousDisposalRows}
                    showSerialNumber={true}
                    showTotal={true}
                    totalValue={wasteToDisposalData?.hazardousWasteDisposalBreakdownTotal?.value || '-'}
                  />
                )
              })()}
            </div>

            {/* Sub-section c: Non-hazardous waste directed to disposal */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                c. What is the total weight of non-hazardous waste directed to disposal in metric tons?
              </p>
              
              {wasteToDisposalData?.nonHazardousWasteDisposalBreakdownTotal && (
                <div className={styles.questionRow}>
                  <span className={styles.questionLabel}>Total:</span>
                  <span className={styles.questionValue}>
                    {wasteToDisposalData?.nonHazardousWasteDisposalBreakdownTotal?.value || '-'} {wasteToDisposalData?.nonHazardousWasteDisposalBreakdownTotal?.unit || ''}
                  </span>
                </div>
              )}
              
              {(() => {
                const nonHazardousDisposalColumns = [
                  { field: 'typeOfWaste', label: 'Type of Waste', width: '50%' },
                  { field: 'quantity', label: 'Quantity', width: '50%' }
                ]
                
                const nonHazardousDisposalRows = wasteToDisposalData?.nonHazardousWasteDisposalBreakdown && Array.isArray(wasteToDisposalData.nonHazardousWasteDisposalBreakdown) && wasteToDisposalData.nonHazardousWasteDisposalBreakdown.length > 0
                  ? wasteToDisposalData.nonHazardousWasteDisposalBreakdown.map((item) => ({
                      typeOfWaste: item?.typeOfWaste || '-',
                      quantity: item?.quantity || '-'
                    }))
                  : [
                      { typeOfWaste: 'Incineration (With energy recovery)', quantity: '-' },
                      { typeOfWaste: 'Incineration (Without energy recovery)', quantity: '-' },
                      { typeOfWaste: 'Landfilling', quantity: '-' }
                    ]
                
                return (
                  <ReportTable
                    columns={nonHazardousDisposalColumns}
                    rows={nonHazardousDisposalRows}
                    showSerialNumber={true}
                    showTotal={true}
                    totalValue={wasteToDisposalData?.nonHazardousWasteDisposalBreakdownTotal?.value || '-'}
                  />
                )
              })()}
            </div>

            {/* Sub-section d: Onsite/Offsite disposal */}
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                d. For every directed disposal outlined in Disclosures 306-5-b and 306-5-c, detail the total weight in metric tons of hazardous waste and non-hazardous waste diverted from disposal.
              </p>
              
              {wasteToDisposalData?.wasteDiversionTotal && (
                <div className={styles.questionRow}>
                  <span className={styles.questionLabel}>Total:</span>
                  <span className={styles.questionValue}>
                    {wasteToDisposalData?.wasteDiversionTotal?.value || '-'} {wasteToDisposalData?.wasteDiversionTotal?.unit || ''}
                  </span>
                </div>
              )}
              
              {(() => {
                const onsiteDisposalColumns = [
                  { field: 'typeOfWaste', label: 'Disposal Type', width: '50%' },
                  { field: 'quantity', label: 'Quantity', width: '50%' }
                ]
                
                const onsiteDisposalRows = wasteToDisposalData?.wasteDiversionTotals && Array.isArray(wasteToDisposalData.wasteDiversionTotals) && wasteToDisposalData.wasteDiversionTotals.length > 0
                  ? wasteToDisposalData.wasteDiversionTotals.map((item) => ({
                      typeOfWaste: item?.typeOfWaste || '-',
                      quantity: item?.quantity || '-'
                    }))
                  : [
                      { typeOfWaste: 'Onsite Disposal', quantity: '-' },
                      { typeOfWaste: 'Offline Disposal', quantity: '-' }
                    ]
                
                return (
                  <ReportTable
                    columns={onsiteDisposalColumns}
                    rows={onsiteDisposalRows}
                    showSerialNumber={true}
                    showTotal={true}
                    totalValue={wasteToDisposalData?.wasteDiversionTotal?.value || '-'}
                  />
                )
              })()}
            </div>

            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                e. Provide contextual information necessary to understand the data and how the data has been compiled.
              </p>
              <p className={styles.questionAnswer}>
                {wasteToDisposalData?.wasteDataContext || '-'}
              </p>
            </div>
          </div>
        ) : (
          <div className={styles.consolidatingSection}>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. Provide the total weight of waste directed to disposal by composition of the waste?
              </p>
              <ReportTable
                columns={[
                  { field: 'typeOfWaste', label: 'Type of Waste', width: '50%' },
                  { field: 'quantity', label: 'Value', width: '50%' }
                ]}
                rows={[
                  { typeOfWaste: 'Hazardous Waste', quantity: '-' },
                  { typeOfWaste: 'Non-Hazardous Waste', quantity: '-' },
                  { typeOfWaste: 'Electronic Waste', quantity: '-' },
                  { typeOfWaste: 'Food Waste', quantity: '-' },
                  { typeOfWaste: 'Biowaste', quantity: '-' }
                ]}
                showSerialNumber={true}
                showTotal={true}
                totalValue={wasteToDisposalData?.wasteDisposalByCompositionTotal?.value || '-'}
              />
            </div>
          </div>
        )}
      </div>

      {/* GRI 308 - Supplier Environmental Assessment */}
      <div className={styles.container}>
        <p className={styles.sectionHeading}>
          308: SUPPLIER ENVIRONMENTAL ASSESSMENT
        </p>
        
        {/* 308-1: New suppliers that were screened using environmental criteria */}
        <h1 className={styles.mainHeading}>
          308-1 : NEW SUPPLIERS THAT WERE SCREENED USING ENVIRONMENTAL CRITERIA
        </h1>
        
        {supplierData ? (
          <div className={styles.consolidatingSection}>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. What is the percentage of new suppliers that were screened using environmental criteria?
              </p>
              <p className={styles.questionAnswer}>
                {supplierData?.newSuppliersScreenedPercentage ? `${supplierData.newSuppliersScreenedPercentage}%` : '-'}
              </p>
            </div>
          </div>
        ) : (
          <div className={styles.consolidatingSection}>
            <div className={styles.questionBox}>
              <p className={`${styles.questionTitle} common_text_style`}>
                a. What is the percentage of new suppliers that were screened using environmental criteria?
              </p>
              <p className={styles.questionAnswer}>
                -
              </p>
            </div>
          </div>
        )}

        {/* 308-2: Negative environmental impacts in the supply chain and actions taken */}
        <h1 className={styles.mainHeading}>
          308-2 : NEGATIVE ENVIRONMENTAL IMPACTS IN THE SUPPLY CHAIN AND ACTIONS TAKEN
        </h1>
        
        {supplyChainImpactsActionsData ? (
          <div className={styles.consolidatingSection}>
            {supplyChainImpactsActionsData?.assessedEnvironmentalImpacts && (
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  a. Number of suppliers assessed for environmental impacts
                </p>
                <p className={styles.questionAnswer}>
                  {supplyChainImpactsActionsData?.assessedEnvironmentalImpacts || '-'}
                </p>
              </div>
            )}

            {supplyChainImpactsActionsData?.withAdverseEnvironmentalImpacts && (
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  b. How many suppliers have been identified as having significant actual and potential adverse environmental impacts?
                </p>
                <p className={styles.questionAnswer}>
                  {supplyChainImpactsActionsData?.withAdverseEnvironmentalImpacts || '-'}
                </p>
              </div>
            )}

            {supplyChainImpactsActionsData?.supplyChainAdverseImpacts && (
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  c. In the supply chain, what significant actual and potential adverse environmental impacts have been identified?
                </p>
                <p className={styles.questionAnswer}>
                  {supplyChainImpactsActionsData?.supplyChainAdverseImpacts || '-'}
                </p>
              </div>
            )}

            {supplyChainImpactsActionsData?.agreedImprovementsPercentage && (
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  d. What percentage of suppliers, identified with significant actual and potential negative environmental impacts, have agreed upon improvements following assessment?
                </p>
                <p className={styles.questionAnswer}>
                  {supplyChainImpactsActionsData?.agreedImprovementsPercentage ? `${supplyChainImpactsActionsData.agreedImprovementsPercentage}%` : '-'}
                </p>
              </div>
            )}

            {supplyChainImpactsActionsData?.supplierTerminationsPercentage && (
              <div className={styles.questionBox}>
                <p className={`${styles.questionTitle} common_text_style`}>
                  e. What percentage of suppliers, identified with significant actual and potential negative environmental impacts, had their relationships terminated as a result of assessment, and what were the reasons for termination?
                </p>
                <p className={styles.questionAnswer}>
                  {supplyChainImpactsActionsData?.supplierTerminationsPercentage ? `${supplyChainImpactsActionsData.supplierTerminationsPercentage}%` : '-'}
                </p>
              </div>
            )}
          </div>
        ) : (
          <div className={styles.consolidatingSection}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                -
              </p>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default GRI300
